// Generated by scripts/generate-geo.ts. Do not edit by hand.
// French subdivision names fall back to English where no localized name is available.
export const geoFrCA = {
  countries: {
    AD: "Andorre",
    AE: "Émirats Arabes Unis",
    AF: "Afghanistan",
    AG: "Antigua-et-Barbuda",
    AI: "Anguilla",
    AL: "Albanie",
    AM: "Arménie",
    AO: "Angola",
    AQ: "Antarctique",
    AR: "Argentine",
    AS: "Samoa américaines",
    AT: "Autriche",
    AU: "Australie",
    AW: "Aruba",
    AX: "Åland",
    AZ: "Azerbaïdjan",
    BA: "Bosnie-Herzégovine",
    BB: "Barbade",
    BD: "Bangladesh",
    BE: "Belgique",
    BF: "Burkina Faso",
    BG: "Bulgarie",
    BH: "Bahreïn",
    BI: "Burundi",
    BJ: "Bénin",
    BL: "Saint-Barthélemy",
    BM: "Bermudes",
    BN: "Brunei Darussalam",
    BO: "Bolivie",
    BQ: "Bonaire, Saint-Eustache et Saba",
    BR: "Brésil",
    BS: "Bahamas",
    BT: "Bhoutan",
    BV: "Île Bouvet",
    BW: "Botswana",
    BY: "Biélorussie",
    BZ: "Belize",
    CA: "Canada",
    CC: "Îles Cocos",
    CD: "République démocratique du Congo",
    CF: "République Centrafricaine",
    CG: "République du Congo",
    CH: "Suisse",
    CI: "Côte-d'Ivoire",
    CK: "Îles Cook",
    CL: "Chili",
    CM: "Cameroun",
    CN: "Chine",
    CO: "Colombie",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cap-Vert",
    CW: "Curaçao",
    CX: "Île Christmas",
    CY: "Chypre",
    CZ: "République Tchèque",
    DE: "Allemagne",
    DJ: "Djibouti",
    DK: "Danemark",
    DM: "Dominique",
    DO: "République Dominicaine",
    DZ: "Algérie",
    EC: "Équateur",
    EE: "Estonie",
    EG: "Égypte",
    EH: "Sahara occidental",
    ER: "Érythrée",
    ES: "Espagne",
    ET: "Éthiopie",
    FI: "Finlande",
    FJ: "Fidji",
    FK: "Îles Malouines",
    FM: "Micronésie",
    FO: "Îles Féroé",
    FR: "France",
    GA: "Gabon",
    GB: "Royaume-Uni",
    GD: "Grenade",
    GE: "Géorgie",
    GF: "Guyane française",
    GG: "Guernesey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Groenland",
    GM: "Gambie",
    GN: "Guinée",
    GP: "Guadeloupe",
    GQ: "Guinée équatoriale",
    GR: "Grèce",
    GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinée-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HM: "Îles Heard-et-MacDonald",
    HN: "Honduras",
    HR: "Croatie",
    HT: "Haïti",
    HU: "Hongrie",
    ID: "Indonésie",
    IE: "Irlande",
    IL: "Israël",
    IM: "Île de Man",
    IN: "Inde",
    IO: "Océan Indien Britannique",
    IQ: "Irak",
    IR: "Iran",
    IS: "Islande",
    IT: "Italie",
    JE: "Jersey",
    JM: "Jamaïque",
    JO: "Jordanie",
    JP: "Japon",
    KE: "Kenya",
    KG: "Kirghizistan",
    KH: "Cambodge",
    KI: "Kiribati",
    KM: "Comores",
    KN: "Saint-Christophe-et-Niévès",
    KP: "Corée du Nord",
    KR: "Corée du Sud",
    KW: "Koweït",
    KY: "Îles Caïmans",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Liban",
    LC: "Sainte-Lucie",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Libéria",
    LS: "Lesotho",
    LT: "Lituanie",
    LU: "Luxembourg",
    LV: "Lettonie",
    LY: "Libye",
    MA: "Maroc",
    MC: "Monaco",
    MD: "Moldavie",
    ME: "Monténégro",
    MF: "Saint-Martin (partie française)",
    MG: "Madagascar",
    MH: "Îles Marshall",
    MK: "Macédoine du Nord",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolie",
    MO: "Macao",
    MP: "Îles Mariannes du Nord",
    MQ: "Martinique",
    MR: "Mauritanie",
    MS: "Montserrat",
    MT: "Malte",
    MU: "Maurice",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexique",
    MY: "Malaisie",
    MZ: "Mozambique",
    NA: "Namibie",
    NC: "Nouvelle-Calédonie",
    NE: "Niger",
    NF: "Île Norfolk",
    NG: "Nigéria",
    NI: "Nicaragua",
    NL: "Pays-Bas",
    NO: "Norvège",
    NP: "Népal",
    NR: "Nauru",
    NU: "Niué",
    NZ: "Nouvelle-Zélande",
    OM: "Oman",
    PA: "Panama",
    PE: "Pérou",
    PF: "Polynésie française",
    PG: "Papouasie-Nouvelle-Guinée",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Pologne",
    PM: "Saint-Pierre-et-Miquelon",
    PN: "Îles Pitcairn",
    PR: "Porto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palaos",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Roumanie",
    RS: "Serbie",
    RU: "Russie",
    RW: "Rwanda",
    SA: "Arabie Saoudite",
    SB: "Îles Salomon",
    SC: "Seychelles",
    SD: "Soudan",
    SE: "Suède",
    SG: "Singapour",
    SH: "Sainte-Hélène",
    SI: "Slovénie",
    SJ: "Svalbard et Île Jan Mayen",
    SK: "Slovaquie",
    SL: "Sierra Leone",
    SM: "Saint-Marin",
    SN: "Sénégal",
    SO: "Somalie",
    SR: "Suriname",
    SS: "Soudan du Sud",
    ST: "São Tomé-et-Principe",
    SV: "El Salvador",
    SX: "Saint-Martin (partie néerlandaise)",
    SY: "Syrie",
    SZ: "Royaume d'Eswatini",
    TC: "Îles Turques-et-Caïques",
    TD: "Tchad",
    TF: "Terres australes françaises",
    TG: "Togo",
    TH: "Thaïlande",
    TJ: "Tadjikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkménistan",
    TN: "Tunisie",
    TO: "Tonga",
    TR: "Turquie",
    TT: "Trinité-et-Tobago",
    TV: "Tuvalu",
    TW: "Taïwan",
    TZ: "République unie de Tanzanie",
    UA: "Ukraine",
    UG: "Ouganda",
    UM: "Îles mineures éloignées des États-Unis",
    US: "États-Unis d'Amérique",
    UY: "Uruguay",
    UZ: "Ouzbékistan",
    VA: "Saint-Siège (Vatican)",
    VC: "Saint-Vincent-et-les-Grenadines",
    VE: "Venezuela",
    VG: "Îles vierges britanniques",
    VI: "Îles vierges américaines",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis-et-Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Yémen",
    YT: "Mayotte",
    ZA: "Afrique du Sud",
    ZM: "Zambie",
    ZW: "Zimbabwe",
  },
  states: {
    AD: {
      "02": "Canillo",
      "03": "Encamp",
      "04": "La Massana",
      "05": "Ordino",
      "06": "Sant Julià de Lòria",
      "07": "Andorra la Vella",
      "08": "Escaldes-Engordany",
    },
    AE: {
      AJ: "Ajman Emirate",
      AZ: "Abu Dhabi Emirate",
      DU: "Dubai",
      FU: "Fujairah",
      RK: "Ras al-Khaimah",
      SH: "Sharjah Emirate",
      UQ: "Umm al-Quwain",
    },
    AF: {
      BAL: "Balkh",
      BAM: "Bamyan",
      BDG: "Badghis",
      BDS: "Badakhshan",
      BGL: "Baghlan",
      DAY: "Daykundi",
      FRA: "Farah",
      FYB: "Faryab",
      GHA: "Ghazni",
      GHO: "Ghōr",
      HEL: "Helmand",
      HER: "Herat",
      JOW: "Jowzjan",
      KAB: "Kabul",
      KAN: "Kandahar",
      KAP: "Kapisa",
      KDZ: "Kunduz Province",
      KHO: "Khost",
      KNR: "Kunar",
      LAG: "Laghman",
      LOG: "Logar",
      NAN: "Nangarhar",
      NIM: "Nimruz",
      NUR: "Nuristan",
      PAN: "Panjshir",
      PAR: "Parwan",
      PIA: "Paktia",
      PKA: "Paktika",
      SAM: "Samangan",
      SAR: "Sar-e Pol",
      TAK: "Takhar",
      URU: "Urozgan",
      ZAB: "Zabul",
    },
    AG: {
      "10": "Barbuda",
      "11": "Redonda",
      "03": "Saint George Parish",
      "04": "Saint John Parish",
      "05": "Saint Mary Parish",
      "06": "Saint Paul Parish",
      "07": "Saint Peter Parish",
      "08": "Saint Philip Parish",
    },
    AL: {
      "10": "Shkodër County",
      "11": "Tirana County",
      "12": "Vlorë County",
      "01": "Berat County",
      "02": "Durrës County",
      "03": "Elbasan County",
      "04": "Fier County",
      "05": "Gjirokastër County",
      "06": "Korçë County",
      "07": "Kukës County",
      "08": "Lezhë County",
      "09": "Dibër County",
      BR: "Berat District",
      BU: "Bulqizë District",
      DI: "Dibër District",
      DL: "Delvinë District",
      DR: "Durrës District",
      DV: "Devoll District",
      ER: "Kolonjë District",
      FR: "Fier District",
      GJ: "Gjirokastër District",
      GR: "Gramsh District",
      HA: "Has District",
      KA: "Kavajë District",
      KB: "Kurbin District",
      KC: "Kuçovë District",
      KO: "Korçë District",
      KR: "Krujë District",
      KU: "Kukës District",
      LB: "Librazhd District",
      LE: "Lezhë District",
      LU: "Lushnjë District",
      MK: "Mallakastër District",
      MM: "Malësi e Madhe District",
      MR: "Mirditë District",
      MT: "Mat District",
      PG: "Pogradec District",
      PQ: "Peqin District",
      PR: "Përmet District",
      PU: "Pukë District",
      SH: "Shkodër District",
      SK: "Skrapar District",
      SR: "Sarandë District",
      TE: "Tepelenë District",
      TP: "Tropojë District",
      TR: "Tirana District",
      VL: "Vlorë District",
    },
    AM: {
      AG: "Aragatsotn Region",
      AR: "Ararat Province",
      AV: "Armavir Region",
      ER: "Yerevan",
      GR: "Gegharkunik Province",
      KT: "Kotayk Region",
      LO: "Lori Region",
      SH: "Shirak Region",
      SU: "Syunik Province",
      TV: "Tavush Region",
      VD: "Vayots Dzor Region",
    },
    AO: {
      BGO: "Bengo Province",
      BGU: "Benguela Province",
      BIE: "Bié Province",
      CAB: "Cabinda Province",
      CCU: "Cuando Cubango Province",
      CNN: "Cunene Province",
      CNO: "Cuanza Norte Province",
      CUS: "Cuanza Sul",
      HUA: "Huambo Province",
      HUI: "Huíla Province",
      LNO: "Lunda Norte Province",
      LSU: "Lunda Sul Province",
      LUA: "Luanda Province",
      MAL: "Malanje Province",
      MOX: "Moxico Province",
      UIG: "Uíge Province",
      ZAI: "Zaire Province",
    },
    AR: {
      A: "Salta",
      B: "Buenos Aires",
      C: "Ciudad Autónoma de Buenos Aires",
      D: "San Luis",
      E: "Entre Ríos",
      F: "La Rioja",
      G: "Santiago del Estero",
      H: "Chaco",
      J: "San Juan",
      K: "Catamarca",
      L: "La Pampa",
      M: "Mendoza",
      N: "Misiones",
      P: "Formosa",
      Q: "Neuquén",
      R: "Río Negro",
      S: "Santa Fe",
      T: "Tucumán",
      U: "Chubut",
      V: "Tierra del Fuego",
      W: "Corrientes",
      X: "Córdoba",
      Y: "Jujuy",
      Z: "Santa Cruz",
    },
    AT: {
      "1": "Burgenland",
      "2": "Carinthia",
      "3": "Lower Austria",
      "4": "Upper Austria",
      "5": "Salzburg",
      "6": "Styria",
      "7": "Tyrol",
      "8": "Vorarlberg",
      "9": "Vienna",
    },
    AU: {
      ACT: "Australian Capital Territory",
      NSW: "New South Wales",
      NT: "Northern Territory",
      QLD: "Queensland",
      SA: "South Australia",
      TAS: "Tasmania",
      VIC: "Victoria",
      WA: "Western Australia",
    },
    AZ: {
      ABS: "Absheron District",
      AGA: "Agstafa District",
      AGC: "Aghjabadi District",
      AGM: "Agdam District",
      AGS: "Agdash District",
      AGU: "Agsu District",
      AST: "Astara District",
      BA: "Baku",
      BAB: "Babek District",
      BAL: "Balakan District",
      BAR: "Barda District",
      BEY: "Beylagan District",
      BIL: "Bilasuvar District",
      CAB: "Jabrayil District",
      CAL: "Jalilabad District",
      CUL: "Julfa District",
      DAS: "Dashkasan District",
      FUZ: "Fizuli District",
      GA: "Ganja",
      GAD: "Gədəbəy",
      GOR: "Goranboy District",
      GOY: "Goychay",
      GYG: "Goygol District",
      HAC: "Hajigabul District",
      IMI: "Imishli District",
      ISM: "Ismailli District",
      KAL: "Kalbajar District",
      KAN: "Kangarli District",
      KUR: "Kurdamir District",
      LA: "Lankaran District",
      LAC: "Lachin District",
      LAN: "Lankaran",
      LER: "Lerik District",
      MAS: "Masally District",
      MI: "Mingachevir",
      NEF: "Neftchala District",
      NX: "Nakhchivan Autonomous Republic",
      OGU: "Oghuz District",
      ORD: "Ordubad District",
      QAB: "Qabala District",
      QAX: "Qakh District",
      QAZ: "Qazakh District",
      QBA: "Quba District",
      QBI: "Qubadli District",
      QOB: "Gobustan District",
      QUS: "Qusar District",
      SA: "Shaki",
      SAB: "Sabirabad District",
      SAD: "Sadarak District",
      SAH: "Shahbuz District",
      SAK: "Shaki District",
      SAL: "Salyan District",
      SAR: "Sharur District",
      SAT: "Saatly District",
      SBN: "Shabran District",
      SIY: "Siazan District",
      SKR: "Shamkir District",
      SM: "Sumqayit",
      SMI: "Shamakhi District",
      SMX: "Samukh District",
      SR: "Shirvan",
      SUS: "Shusha District",
      TAR: "Tartar District",
      TOV: "Tovuz District",
      UCA: "Ujar District",
      XAC: "Khachmaz District",
      XCI: "Khojali District",
      XIZ: "Khizi District",
      XVD: "Martuni",
      YAR: "Yardymli District",
      YE: "Yevlakh",
      YEV: "Yevlakh District",
      ZAN: "Zangilan District",
      ZAQ: "Zaqatala District",
      ZAR: "Zardab District",
    },
    BA: {
      "10": "Canton 10",
      "01": "Una-Sana Canton",
      "02": "Posavina Canton",
      "03": "Tuzla Canton",
      "04": "Zenica-Doboj Canton",
      "05": "Bosnian Podrinje Canton",
      "06": "Central Bosnia Canton",
      "07": "Herzegovina-Neretva Canton",
      "08": "West Herzegovina Canton",
      "09": "Sarajevo Canton",
      BIH: "Federation of Bosnia and Herzegovina",
      BRC: "Brčko District",
      SRP: "Republika Srpska",
    },
    BB: {
      "10": "Saint Philip",
      "11": "Saint Thomas",
      "01": "Christ Church",
      "02": "Saint Andrew",
      "03": "Saint George",
      "04": "Saint James",
      "05": "Saint John",
      "06": "Saint Joseph",
      "07": "Saint Lucy",
      "08": "Saint Michael",
      "09": "Saint Peter",
    },
    BD: {
      "10": "Chittagong District",
      "11": "Cox's Bazar District",
      "12": "Chuadanga District",
      "13": "Dhaka District",
      "14": "Dinajpur District",
      "15": "Faridpur District",
      "16": "Feni District",
      "17": "Gopalganj District",
      "18": "Gazipur District",
      "19": "Gaibandha District",
      "20": "Habiganj District",
      "21": "Jamalpur District",
      "22": "Jessore District",
      "23": "Jhenaidah District",
      "24": "Joypurhat District",
      "25": "Jhalokati District",
      "26": "Kishoreganj District",
      "27": "Khulna District",
      "28": "Kurigram District",
      "29": "Khagrachari District",
      "30": "Kushtia District",
      "31": "Lakshmipur District",
      "32": "Lalmonirhat District",
      "33": "Bahadia",
      "34": "Mymensingh District",
      "35": "Munshiganj District",
      "36": "Madaripur District",
      "38": "Moulvibazar District",
      "39": "Meherpur District",
      "40": "Narayanganj District",
      "41": "Netrokona District",
      "43": "Narail District",
      "44": "Natore District",
      "45": "Chapai Nawabganj District",
      "46": "Nilphamari District",
      "47": "Noakhali District",
      "48": "Naogaon District",
      "49": "Pabna District",
      "50": "Pirojpur District",
      "51": "Patuakhali District",
      "52": "Panchagarh District",
      "53": "Rajbari District",
      "54": "Rajshahi District",
      "55": "Rangpur District",
      "56": "Rangamati Hill District",
      "57": "Sherpur District",
      "58": "Satkhira District",
      "59": "Sirajganj District",
      "60": "Sylhet District",
      "61": "Sunamganj District",
      "62": "Shariatpur District",
      "63": "Tangail District",
      "64": "Thakurgaon District",
      "01": "Bandarban District",
      "02": "Barguna District",
      "03": "Bogra District",
      "04": "Brahmanbaria District",
      "05": "Bagerhat District",
      "06": "Barisal District",
      "07": "Bhola District",
      "08": "Comilla District",
      "09": "Chandpur District",
      A: "Barisal Division",
      B: "Chittagong Division",
      C: "Dhaka Division",
      D: "Khulna Division",
      E: "Rajshahi Division",
      F: "Rangpur Division",
      G: "Sylhet Division",
      H: "Mymensingh Division",
    },
    BE: {
      BRU: "Brussels-Capital Region",
      VAN: "Antwerp",
      VBR: "Flemish Brabant",
      VLG: "Flanders",
      VLI: "Limburg",
      VOV: "East Flanders",
      VWV: "West Flanders",
      WAL: "Wallonia",
      WBR: "Walloon Brabant",
      WHT: "Hainaut",
      WLG: "Liège",
      WLX: "Luxembourg",
      WNA: "Namur",
    },
    BF: {
      "10": "Nord Region, Burkina Faso",
      "11": "Plateau-Central Region",
      "12": "Sahel Region",
      "13": "Sud-Ouest Region",
      "01": "Boucle du Mouhoun Region",
      "02": "Cascades Region",
      "03": "Centre",
      "04": "Centre-Est Region",
      "05": "Centre-Nord Region",
      "06": "Centre-Ouest Region",
      "07": "Centre-Sud Region",
      "08": "Est Region",
      "09": "Hauts-Bassins Region",
      BAL: "Balé Province",
      BAM: "Bam Province",
      BAN: "Banwa Province",
      BAZ: "Bazèga Province",
      BGR: "Bougouriba Province",
      BLG: "Boulgou",
      COM: "Comoé Province",
      GAN: "Ganzourgou Province",
      GNA: "Gnagna Province",
      GOU: "Gourma Province",
      HOU: "Houet Province",
      IOB: "Ioba Province",
      KAD: "Kadiogo Province",
      KEN: "Kénédougou Province",
      KMD: "Komondjari Province",
      KMP: "Kompienga Province",
      KOP: "Koulpélogo Province",
      KOS: "Kossi Province",
      KOT: "Kouritenga Province",
      KOW: "Kourwéogo Province",
      LER: "Léraba Province",
      LOR: "Loroum Province",
      MOU: "Mouhoun",
      NAM: "Namentenga Province",
      NAO: "Nahouri Province",
      NAY: "Nayala Province",
      NOU: "Noumbiel Province",
      OUB: "Oubritenga Province",
      OUD: "Oudalan Province",
      PAS: "Passoré Province",
      PON: "Poni Province",
      SEN: "Séno Province",
      SIS: "Sissili Province",
      SMT: "Sanmatenga Province",
      SNG: "Sanguié Province",
      SOM: "Soum Province",
      SOR: "Sourou Province",
      TAP: "Tapoa Province",
      TUI: "Tuy Province",
      YAG: "Yagha Province",
      YAT: "Yatenga Province",
      ZIR: "Ziro Province",
      ZON: "Zondoma Province",
      ZOU: "Zoundwéogo Province",
    },
    BG: {
      "10": "Kyustendil Province",
      "11": "Lovech Province",
      "12": "Montana Province",
      "13": "Pazardzhik Province",
      "14": "Pernik Province",
      "15": "Pleven Province",
      "16": "Plovdiv Province",
      "17": "Razgrad Province",
      "18": "Ruse Province",
      "19": "Silistra Province",
      "20": "Sliven Province",
      "21": "Smolyan Province",
      "22": "Sofia City Province",
      "23": "Sofia Province",
      "24": "Stara Zagora Province",
      "25": "Targovishte Province",
      "26": "Haskovo Province",
      "27": "Shumen",
      "28": "Yambol Province",
      "01": "Blagoevgrad Province",
      "02": "Burgas Province",
      "03": "Varna Province",
      "04": "Veliko Tarnovo Province",
      "05": "Vidin Province",
      "06": "Vratsa Province",
      "07": "Gabrovo Province",
      "08": "Dobrich Province",
      "09": "Kardzhali Province",
    },
    BH: {
      "13": "Capital Governorate",
      "14": "Southern Governorate",
      "15": "Muharraq Governorate",
      "16": "Central Governorate",
      "17": "Northern Governorate",
    },
    BI: {
      BB: "Bubanza Province",
      BL: "Bujumbura Rural Province",
      BM: "Bujumbura Mairie Province",
      BR: "Bururi Province",
      CA: "Cankuzo Province",
      CI: "Cibitoke Province",
      GI: "Gitega Province",
      KI: "Kirundo Province",
      KR: "Karuzi Province",
      KY: "Kayanza Province",
      MA: "Makamba Province",
      MU: "Muramvya Province",
      MW: "Mwaro Province",
      MY: "Muyinga Province",
      NG: "Ngozi Province",
      RM: "Rumonge Province",
      RT: "Rutana Province",
      RY: "Ruyigi Province",
    },
    BJ: {
      AK: "Atakora Department",
      AL: "Alibori Department",
      AQ: "Atlantique Department",
      BO: "Borgou Department",
      CO: "Collines Department",
      DO: "Donga Department",
      KO: "Kouffo Department",
      LI: "Littoral Department",
      MO: "Mono Department",
      OU: "Ouémé Department",
      PL: "Plateau Department",
      ZO: "Zou Department",
    },
    BM: {
      DEV: "Devonshire Parish",
      HA: "Hamilton Parish",
      PAG: "Paget Parish",
      PEM: "Pembroke Parish",
      SAN: "Sandys Parish",
      SGE: "Saint George's Parish",
      SMI: "Smith's Parish,",
      SOU: "Southampton Parish",
      WAR: "Warwick Parish",
    },
    BN: {
      BE: "Belait District",
      BM: "Brunei-Muara District",
      TE: "Temburong District",
      TU: "Tutong District",
    },
    BO: {
      B: "Beni Department",
      C: "Cochabamba Department",
      H: "Chuquisaca Department",
      L: "La Paz Department",
      N: "Pando Department",
      O: "Oruro Department",
      P: "Potosí Department",
      S: "Santa Cruz Department",
      T: "Tarija Department",
    },
    BR: {
      AC: "Acre",
      AL: "Alagoas",
      AM: "Amazonas",
      AP: "Amapá",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MG: "Minas Gerais",
      MS: "Mato Grosso do Sul",
      MT: "Mato Grosso",
      PA: "Pará",
      PB: "Paraíba",
      PE: "Pernambuco",
      PI: "Piauí",
      PR: "Paraná",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RO: "Rondônia",
      RR: "Roraima",
      RS: "Rio Grande do Sul",
      SC: "Santa Catarina",
      SE: "Sergipe",
      SP: "São Paulo",
      TO: "Tocantins",
    },
    BS: {
      AC: "Acklins and Crooked Islands",
      AK: "Acklins",
      BI: "Bimini",
      BP: "Black Point",
      BY: "Berry Islands",
      CE: "Central Eleuthera",
      CI: "Cat Island",
      CK: "Crooked Island",
      CO: "Central Abaco",
      CS: "Central Andros",
      EG: "East Grand Bahama",
      EX: "Exuma",
      FC: "Fresh Creek",
      FP: "Freeport",
      GC: "Grand Cay",
      GH: "Governor's Harbour",
      GT: "Green Turtle Cay",
      HI: "Harbour Island",
      HR: "High Rock",
      HT: "Hope Town",
      IN: "Inagua",
      KB: "Kemps Bay",
      LI: "Long Island",
      MC: "Mangrove Cay",
      MG: "Mayaguana District",
      MH: "Marsh Harbour",
      NB: "Nichollstown and Berry Islands",
      NE: "North Eleuthera",
      NO: "North Abaco",
      NP: "New Providence",
      NS: "North Andros",
      RC: "Rum Cay District",
      RI: "Ragged Island",
      RS: "Rock Sound",
      SA: "South Andros",
      SE: "South Eleuthera",
      SO: "South Abaco",
      SP: "Sandy Point",
      SR: "San Salvador and Rum Cay",
      SS: "San Salvador Island",
      SW: "Spanish Wells",
      WG: "West Grand Bahama",
    },
    BT: {
      "11": "Paro District",
      "12": "Chukha District",
      "13": "Haa District",
      "14": "Samtse District",
      "15": "Thimphu District",
      "21": "Tsirang District",
      "22": "Dagana District",
      "23": "Punakha District",
      "24": "Wangdue Phodrang District",
      "31": "Sarpang District",
      "32": "Trongsa District",
      "33": "Bumthang District",
      "34": "Zhemgang District",
      "41": "Trashigang District",
      "42": "Mongar District",
      "43": "Pemagatshel District",
      "44": "Lhuntse District",
      "45": "Samdrup Jongkhar District",
      GA: "Gasa District",
    },
    BW: {
      CE: "Central District",
      GH: "Ghanzi District",
      KG: "Kgalagadi District",
      KL: "Kgatleng District",
      KW: "Kweneng District",
      NE: "North-East District",
      NG: "Ngamiland",
      NW: "North-West District",
      SE: "South-East District",
      SO: "Southern District",
    },
    BY: {
      BR: "Brest Region",
      HM: "Minsk",
      HO: "Gomel Region",
      HR: "Grodno Region",
      MA: "Mogilev Region",
      MI: "Minsk Region",
      VI: "Vitebsk Region",
    },
    BZ: {
      BZ: "Belize District",
      CY: "Cayo District",
      CZL: "Corozal District",
      OW: "Orange Walk District",
      SC: "Stann Creek District",
      TOL: "Toledo District",
    },
    CA: {
      AB: "Alberta",
      BC: "British Columbia",
      MB: "Manitoba",
      NB: "New Brunswick",
      NL: "Newfoundland and Labrador",
      NS: "Nova Scotia",
      NT: "Northwest Territories",
      NU: "Nunavut",
      ON: "Ontario",
      PE: "Prince Edward Island",
      QC: "Quebec",
      SK: "Saskatchewan",
      YT: "Yukon",
    },
    CD: {
      BC: "Kongo Central",
      BU: "Bas-Uélé",
      EQ: "Équateur",
      HK: "Haut-Katanga",
      HL: "Haut-Lomami",
      HU: "Haut-Uélé",
      IT: "Ituri",
      KC: "Kasaï Central",
      KE: "Kasaï Oriental",
      KG: "Kwango",
      KL: "Kwilu",
      KN: "Kinshasa",
      KS: "Kasaï",
      LO: "Lomami",
      LU: "Lualaba",
      MA: "Maniema",
      MN: "Mai-Ndombe",
      MO: "Mongala",
      NK: "Nord-Kivu",
      NU: "Nord-Ubangi",
      SA: "Sankuru",
      SK: "Sud-Kivu",
      SU: "Sud-Ubangi",
      TA: "Tanganyika",
      TO: "Tshopo",
      TU: "Tshuapa",
    },
    CF: {
      AC: "Ouham Prefecture",
      BB: "Bamingui-Bangoran Prefecture",
      BGF: "Bangui",
      BK: "Basse-Kotto Prefecture",
      HK: "Haute-Kotto Prefecture",
      HM: "Haut-Mbomou Prefecture",
      HS: "Mambéré-Kadéï",
      KB: "Nana-Grébizi Economic Prefecture",
      KG: "Kémo Prefecture",
      LB: "Lobaye Prefecture",
      MB: "Mbomou Prefecture",
      MP: "Ombella-M'Poko Prefecture",
      NM: "Nana-Mambéré Prefecture",
      OP: "Ouham-Pendé Prefecture",
      SE: "Sangha-Mbaéré",
      UK: "Ouaka Prefecture",
      VK: "Vakaga Prefecture",
    },
    CG: {
      "2": "Lékoumou Department",
      "5": "Kouilou Department",
      "7": "Likouala Department",
      "8": "Cuvette Department",
      "9": "Niari Department",
      "11": "Bouenza Department",
      "12": "Pool Department",
      "13": "Sangha Department",
      "14": "Plateaux Department",
      "15": "Cuvette-Ouest Department",
      "16": "Pointe-Noire",
      BZV: "Brazzaville",
    },
    CH: {
      AG: "Aargau",
      AI: "Appenzell Innerrhoden",
      AR: "Appenzell Ausserrhoden",
      BE: "Bern",
      BL: "Basel-Land",
      BS: "Basel-Stadt",
      FR: "Fribourg",
      GE: "Geneva",
      GL: "Glarus",
      GR: "Graubünden",
      JU: "Jura",
      LU: "Lucerne",
      NE: "Neuchâtel",
      NW: "Nidwalden",
      OW: "Obwalden",
      SG: "St. Gallen",
      SH: "Schaffhausen",
      SO: "Solothurn",
      SZ: "Schwyz",
      TG: "Thurgau",
      TI: "Ticino",
      UR: "Uri",
      VD: "Vaud",
      VS: "Valais",
      ZG: "Zug",
      ZH: "Zürich",
    },
    CI: {
      "10": "Denguélé Region",
      "11": "N'zi-Comoé",
      "12": "Marahoué Region",
      "13": "Sud-Comoé",
      "14": "Worodougou",
      "15": "Sud-Bandama",
      "16": "Agnéby",
      "17": "Bafing Region",
      "18": "Fromager",
      "19": "Moyen-Cavally",
      "01": "Lagunes region",
      "02": "Haut-Sassandra",
      "03": "Savanes Region",
      "04": "Vallée du Bandama Region",
      "05": "Moyen-Comoé",
      "06": "Dix-Huit Montagnes",
      "07": "Lacs Region",
      "09": "Bas-Sassandra Region",
      AB: "Abidjan",
      BS: "Bas-Sassandra District",
      CM: "Comoé District",
      DN: "Denguélé District",
      GD: "Gôh-Djiboua District",
      LC: "Lacs District",
      LG: "Lagunes District",
      MG: "Montagnes District",
      SM: "Sassandra-Marahoué District",
      VB: "Vallée du Bandama District",
      WR: "Woroba District",
      YM: "Yamoussoukro",
      ZZ: "Zanzan Region",
    },
    CL: {
      AI: "Aisén del General Carlos Ibañez del Campo",
      AN: "Antofagasta",
      AP: "Arica y Parinacota",
      AR: "La Araucanía",
      AT: "Atacama",
      BI: "Biobío",
      CO: "Coquimbo",
      LI: "Libertador General Bernardo O'Higgins",
      LL: "Los Lagos",
      LR: "Los Ríos",
      MA: "Magallanes y de la Antártica Chilena",
      ML: "Maule",
      NB: "Ñuble",
      RM: "Región Metropolitana de Santiago",
      TA: "Tarapacá",
      VS: "Valparaíso",
    },
    CM: {
      AD: "Adamawa",
      CE: "Centre",
      EN: "Far North",
      ES: "East",
      LT: "Littoral",
      NO: "North",
      NW: "Northwest",
      OU: "West",
      SU: "South",
      SW: "Southwest",
    },
    CN: {
      AH: "Anhui",
      BJ: "Beijing",
      CQ: "Chongqing",
      FJ: "Fujian",
      GD: "Guangdong",
      GS: "Gansu",
      GX: "Guangxi Zhuang",
      GZ: "Guizhou",
      HA: "Henan",
      HB: "Hubei",
      HE: "Hebei",
      HI: "Hainan",
      HK: "Hong Kong SAR",
      HL: "Heilongjiang",
      HN: "Hunan",
      JL: "Jilin",
      JS: "Jiangsu",
      JX: "Jiangxi",
      LN: "Liaoning",
      MO: "Macau SAR",
      NM: "Inner Mongolia",
      NX: "Ningxia Huizu",
      QH: "Qinghai",
      SC: "Sichuan",
      SD: "Shandong",
      SH: "Shanghai",
      SN: "Shaanxi",
      SX: "Shanxi",
      TJ: "Tianjin",
      TW: "Taiwan",
      XJ: "Xinjiang",
      XZ: "Xizang",
      YN: "Yunnan",
      ZJ: "Zhejiang",
    },
    CO: {
      AMA: "Amazonas",
      ANT: "Antioquia",
      ARA: "Arauca",
      ATL: "Atlántico",
      BOL: "Bolívar",
      BOY: "Boyacá",
      CAL: "Caldas",
      CAQ: "Caquetá",
      CAS: "Casanare",
      CAU: "Cauca",
      CES: "Cesar",
      CHO: "Chocó",
      COR: "Córdoba",
      CUN: "Cundinamarca",
      DC: "Bogotá D.C.",
      GUA: "Guainía",
      GUV: "Guaviare",
      HUI: "Huila",
      LAG: "La Guajira",
      MAG: "Magdalena",
      MET: "Meta",
      NAR: "Nariño",
      NSA: "Norte de Santander",
      PUT: "Putumayo",
      QUI: "Quindío",
      RIS: "Risaralda",
      SAN: "Santander",
      SAP: "Archipiélago de San Andrés, Providencia y Santa Catalina",
      SUC: "Sucre",
      TOL: "Tolima",
      VAC: "Valle del Cauca",
      VAU: "Vaupés",
      VID: "Vichada",
    },
    CR: {
      A: "Alajuela Province",
      C: "Provincia de Cartago",
      G: "Guanacaste Province",
      H: "Heredia Province",
      L: "Limón Province",
      P: "Puntarenas Province",
      SJ: "San José Province",
    },
    CU: {
      "10": "Las Tunas Province",
      "11": "Holguín Province",
      "12": "Granma Province",
      "13": "Santiago de Cuba Province",
      "14": "Guantánamo Province",
      "15": "Artemisa Province",
      "16": "Mayabeque Province",
      "99": "Isla de la Juventud",
      "01": "Pinar del Río Province",
      "03": "Havana Province",
      "04": "Matanzas Province",
      "05": "Villa Clara Province",
      "06": "Cienfuegos Province",
      "07": "Sancti Spíritus Province",
      "08": "Ciego de Ávila Province",
      "09": "Camagüey Province",
    },
    CV: {
      B: "Barlavento Islands",
      BR: "Brava",
      BV: "Boa Vista",
      CA: "Santa Catarina",
      CF: "Santa Catarina do Fogo",
      CR: "Santa Cruz",
      MA: "Maio Municipality",
      MO: "Mosteiros",
      PA: "Paul",
      PN: "Porto Novo",
      PR: "Praia",
      RB: "Ribeira Brava Municipality",
      RG: "Ribeira Grande",
      RS: "Ribeira Grande de Santiago",
      S: "Sotavento Islands",
      SD: "São Domingos",
      SF: "São Filipe",
      SL: "Sal",
      SM: "São Miguel",
      SO: "São Lourenço dos Órgãos",
      SV: "São Vicente",
      TA: "Tarrafal",
      TS: "Tarrafal de São Nicolau",
    },
    CY: {
      "01": "Nicosia District (Lefkoşa)",
      "02": "Limassol District (Leymasun)",
      "03": "Larnaca District (Larnaka)",
      "04": "Famagusta District (Mağusa)",
      "05": "Paphos District (Pafos)",
      "06": "Kyrenia District (Keryneia)",
    },
    CZ: {
      "10": "Praha, Hlavní město",
      "20": "Středočeský kraj",
      "31": "Jihočeský kraj",
      "32": "Plzeňský kraj",
      "41": "Karlovarský kraj",
      "42": "Ústecký kraj",
      "51": "Liberecký kraj",
      "52": "Královéhradecký kraj",
      "53": "Pardubický kraj",
      "63": "Kraj Vysočina",
      "64": "Jihomoravský kraj",
      "71": "Olomoucký kraj",
      "72": "Zlínský kraj",
      "80": "Moravskoslezský kraj",
      "201": "Benešov",
      "202": "Beroun",
      "203": "Kladno",
      "204": "Kolín",
      "205": "Kutná Hora",
      "206": "Mělník",
      "207": "Mladá Boleslav",
      "208": "Nymburk",
      "209": "Praha-východ",
      "311": "České Budějovice",
      "312": "Český Krumlov",
      "313": "Jindřichův Hradec",
      "314": "Písek",
      "315": "Prachatice",
      "316": "Strakonice",
      "317": "Tábor",
      "321": "Domažlice",
      "322": "Klatovy",
      "323": "Plzeň-město",
      "324": "Plzeň-jih",
      "325": "Plzeň-sever",
      "326": "Rokycany",
      "327": "Tachov",
      "411": "Cheb",
      "412": "Karlovy Vary",
      "413": "Sokolov",
      "421": "Děčín",
      "422": "Chomutov",
      "423": "Litoměřice",
      "424": "Louny",
      "425": "Most",
      "426": "Teplice",
      "427": "Ústí nad Labem",
      "511": "Česká Lípa",
      "512": "Jablonec nad Nisou",
      "513": "Liberec",
      "514": "Semily",
      "521": "Hradec Králové",
      "522": "Jičín",
      "523": "Náchod",
      "524": "Rychnov nad Kněžnou",
      "525": "Trutnov",
      "531": "Chrudim",
      "532": "Pardubice",
      "533": "Svitavy",
      "534": "Ústí nad Orlicí",
      "631": "Havlíčkův Brod",
      "632": "Jihlava",
      "633": "Pelhřimov",
      "634": "Třebíč",
      "635": "Žďár nad Sázavou",
      "641": "Blansko",
      "642": "Brno-město",
      "643": "Brno-venkov",
      "644": "Břeclav",
      "645": "Hodonín",
      "646": "Vyškov",
      "647": "Znojmo",
      "711": "Jeseník",
      "712": "Olomouc",
      "713": "Prostějov",
      "714": "Přerov",
      "715": "Šumperk",
      "721": "Kroměříž",
      "722": "Uherské Hradiště",
      "723": "Vsetín",
      "724": "Zlín",
      "801": "Bruntál",
      "802": "Frýdek-Místek",
      "803": "Karviná",
      "804": "Nový Jičín",
      "805": "Opava",
      "806": "Ostrava-město",
      "20A": "Praha-západ",
      "20B": "Příbram",
      "20C": "Rakovník",
    },
    DE: {
      BB: "Brandenburg",
      BE: "Berlin",
      BW: "Baden-Württemberg",
      BY: "Bavaria",
      HB: "Bremen",
      HE: "Hesse",
      HH: "Hamburg",
      MV: "Mecklenburg-Vorpommern",
      NI: "Lower Saxony",
      NW: "North Rhine-Westphalia",
      RP: "Rhineland-Palatinate",
      SH: "Schleswig-Holstein",
      SL: "Saarland",
      SN: "Saxony",
      ST: "Saxony-Anhalt",
      TH: "Thuringia",
    },
    DJ: {
      AR: "Arta Region",
      AS: "Ali Sabieh Region",
      DI: "Dikhil Region",
      DJ: "Djibouti",
      OB: "Obock Region",
      TA: "Tadjourah Region",
    },
    DK: {
      "81": "North Denmark Region",
      "82": "Central Denmark Region",
      "83": "Region of Southern Denmark",
      "84": "Capital Region of Denmark",
      "85": "Region Zealand",
    },
    DM: {
      "10": "Saint Paul Parish",
      "11": "Saint Peter Parish",
      "02": "Saint Andrew Parish",
      "03": "Saint David Parish",
      "04": "Saint George Parish",
      "05": "Saint John Parish",
      "06": "Saint Joseph Parish",
      "07": "Saint Luke Parish",
      "08": "Saint Mark Parish",
      "09": "Saint Patrick Parish",
    },
    DO: {
      "10": "Independencia",
      "11": "La Altagracia Province",
      "12": "La Romana Province",
      "13": "La Vega Province",
      "14": "María Trinidad Sánchez Province",
      "15": "Monte Cristi Province",
      "16": "Pedernales Province",
      "17": "Peravia Province",
      "18": "Puerto Plata Province",
      "19": "Hermanas Mirabal Province",
      "20": "Samaná Province",
      "21": "San Cristóbal Province",
      "22": "San Juan Province",
      "23": "San Pedro de Macorís",
      "24": "Sánchez Ramírez Province",
      "25": "Santiago Province",
      "26": "Santiago Rodríguez Province",
      "27": "Valverde Province",
      "28": "Monseñor Nouel Province",
      "29": "Monte Plata Province",
      "30": "Hato Mayor Province",
      "31": "San José de Ocoa Province",
      "32": "Santo Domingo Province",
      "01": "Distrito Nacional",
      "02": "Azua Province",
      "03": "Baoruco Province",
      "04": "Barahona Province",
      "05": "Dajabón Province",
      "06": "Duarte Province",
      "08": "El Seibo Province",
      "09": "Espaillat Province",
    },
    DZ: {
      "10": "Bouïra",
      "11": "Tamanghasset",
      "12": "Tébessa",
      "13": "Tlemcen",
      "14": "Tiaret",
      "15": "Tizi Ouzou",
      "16": "Algiers",
      "17": "Djelfa",
      "18": "Jijel",
      "19": "Sétif",
      "20": "Saïda",
      "21": "Skikda",
      "22": "Sidi Bel Abbès",
      "23": "Annaba",
      "24": "Guelma",
      "25": "Constantine",
      "26": "Médéa",
      "27": "Mostaganem",
      "28": "M'Sila",
      "29": "Mascara",
      "30": "Ouargla",
      "31": "Oran",
      "32": "El Bayadh",
      "33": "Illizi",
      "34": "Bordj Bou Arréridj",
      "35": "Boumerdès",
      "36": "El Tarf",
      "37": "Tindouf",
      "38": "Tissemsilt",
      "39": "El Oued",
      "40": "Khenchela",
      "41": "Souk Ahras",
      "42": "Tipasa",
      "43": "Mila",
      "44": "Aïn Defla",
      "45": "Naama",
      "46": "Aïn Témouchent",
      "47": "Ghardaïa",
      "48": "Relizane",
      "49": "El M'ghair",
      "50": "El Menia",
      "51": "Ouled Djellal",
      "52": "Bordj Baji Mokhtar",
      "53": "Béni Abbès",
      "54": "Timimoun",
      "55": "Touggourt",
      "56": "Djanet",
      "57": "In Salah",
      "58": "In Guezzam",
      "01": "Adrar",
      "02": "Chlef",
      "03": "Laghouat",
      "04": "Oum El Bouaghi",
      "05": "Batna",
      "06": "Béjaïa",
      "07": "Biskra",
      "08": "Béchar",
      "09": "Blida",
    },
    EC: {
      A: "Azuay",
      B: "Bolívar",
      C: "Carchi",
      D: "Orellana",
      E: "Esmeraldas",
      F: "Cañar",
      G: "Guayas",
      H: "Chimborazo",
      I: "Imbabura",
      L: "Loja",
      M: "Manabí",
      N: "Napo",
      O: "El Oro",
      P: "Pichincha",
      R: "Los Ríos",
      S: "Morona-Santiago",
      SD: "Santo Domingo de los Tsáchilas",
      SE: "Santa Elena",
      T: "Tungurahua",
      U: "Sucumbíos",
      W: "Galápagos",
      X: "Cotopaxi",
      Y: "Pastaza",
      Z: "Zamora Chinchipe",
    },
    EE: {
      "37": "Harju County",
      "39": "Hiiu County",
      "44": "Ida-Viru County",
      "49": "Jõgeva County",
      "51": "Järva County",
      "57": "Lääne County",
      "59": "Lääne-Viru County",
      "65": "Põlva County",
      "67": "Pärnu County",
      "70": "Rapla County",
      "74": "Saare County",
      "78": "Tartu County",
      "82": "Valga County",
      "84": "Viljandi County",
      "86": "Võru County",
    },
    EG: {
      ALX: "Alexandria",
      ASN: "Aswan",
      AST: "Asyut",
      BA: "Red Sea",
      BH: "Beheira",
      BNS: "Beni Suef",
      C: "Cairo",
      DK: "Dakahlia",
      DT: "Damietta",
      FYM: "Faiyum",
      GH: "Gharbia",
      GZ: "Giza",
      IS: "Ismailia",
      JS: "South Sinai",
      KB: "Qalyubia",
      KFS: "Kafr el-Sheikh",
      KN: "Qena",
      LX: "Luxor",
      MN: "Minya",
      MNF: "Monufia",
      MT: "Matrouh",
      PTS: "Port Said",
      SHG: "Sohag",
      SHR: "Sharqia",
      SIN: "North Sinai",
      SUZ: "Suez",
      WAD: "New Valley",
    },
    ER: {
      AN: "Anseba Region",
      DK: "Southern Red Sea Region",
      DU: "Debub Region",
      GB: "Gash-Barka Region",
      MA: "Maekel Region",
      SK: "Northern Red Sea Region",
    },
    ES: {
      AN: "Andalusia",
      AR: "Aragon",
      AS: "Asturias",
      AV: "Ávila",
      BU: "Burgos Province",
      CB: "Cantabria",
      CE: "Ceuta",
      CL: "Castile and León",
      CM: "Castilla La Mancha",
      CN: "Canary Islands",
      CT: "Catalonia",
      EX: "Extremadura",
      GA: "Galicia",
      LE: "Léon",
      MC: "Murcia",
      MD: "Madrid",
      ML: "Melilla",
      NC: "Navarra",
      P: "Palencia Province",
      PM: "Balearic Islands",
      PV: "Basque Country",
      RI: "La Rioja",
      SA: "Salamanca Province",
      SG: "Segovia Province",
      SO: "Soria Province",
      VA: "Valladolid Province",
      VC: "Valencia",
      ZA: "Zamora Province",
    },
    ET: {
      AA: "Addis Ababa",
      AF: "Afar Region",
      AM: "Amhara Region",
      BE: "Benishangul-Gumuz Region",
      DD: "Dire Dawa",
      GA: "Gambela Region",
      HA: "Harari Region",
      OR: "Oromia Region",
      SN: "Southern Nations, Nationalities, and Peoples' Region",
      SO: "Somali Region",
      TI: "Tigray Region",
    },
    FI: {
      "11": "Pirkanmaa",
      "12": "Ostrobothnia",
      "13": "North Karelia",
      "14": "Northern Ostrobothnia",
      "15": "Northern Savonia",
      "16": "Päijänne Tavastia",
      "17": "Satakunta",
      "18": "Uusimaa",
      "19": "Finland Proper",
      "01": "Åland Islands",
      "02": "South Karelia",
      "03": "Southern Ostrobothnia",
      "04": "Southern Savonia",
      "05": "Kainuu",
      "06": "Tavastia Proper",
      "07": "Central Ostrobothnia",
      "08": "Central Finland",
      "09": "Kymenlaakso",
      IS: "Eastern Finland Province",
      LL: "Lapland",
      OL: "Oulu Province",
    },
    FJ: {
      "10": "Namosi",
      "11": "Ra",
      "12": "Rewa",
      "13": "Serua",
      "14": "Tailevu",
      "01": "Ba",
      "02": "Bua",
      "03": "Cakaudrove",
      "04": "Kadavu",
      "05": "Lau",
      "06": "Lomaiviti",
      "07": "Macuata",
      "08": "Nadroga-Navosa",
      "09": "Naitasiri",
      C: "Central Division",
      E: "Eastern Division",
      N: "Northern Division",
      R: "Rotuma",
      W: "Western Division",
    },
    FM: {
      KSA: "Kosrae State",
      PNI: "Pohnpei State",
      TRK: "Chuuk State",
      YAP: "Yap State",
    },
    FR: {
      "10": "Aube",
      "11": "Aude",
      "12": "Aveyron",
      "13": "Bouches-du-Rhône",
      "14": "Calvados",
      "15": "Cantal",
      "16": "Charente",
      "17": "Charente-Maritime",
      "18": "Cher",
      "19": "Corrèze",
      "21": "Côte-d'Or",
      "22": "Côtes-d'Armor",
      "23": "Creuse",
      "24": "Dordogne",
      "25": "Doubs",
      "26": "Drôme",
      "27": "Eure",
      "28": "Eure-et-Loir",
      "29": "Finistère",
      "30": "Gard",
      "31": "Haute-Garonne",
      "32": "Gers",
      "33": "Gironde",
      "34": "Hérault",
      "35": "Ille-et-Vilaine",
      "36": "Indre",
      "37": "Indre-et-Loire",
      "38": "Isère",
      "39": "Jura",
      "40": "Landes",
      "41": "Loir-et-Cher",
      "42": "Loire",
      "43": "Haute-Loire",
      "44": "Loire-Atlantique",
      "45": "Loiret",
      "46": "Lot",
      "47": "Lot-et-Garonne",
      "48": "Lozère",
      "49": "Maine-et-Loire",
      "50": "Manche",
      "51": "Marne",
      "52": "Haute-Marne",
      "53": "Mayenne",
      "54": "Meurthe-et-Moselle",
      "55": "Meuse",
      "56": "Morbihan",
      "57": "Moselle",
      "58": "Nièvre",
      "59": "Nord",
      "60": "Oise",
      "61": "Orne",
      "62": "Pas-de-Calais",
      "63": "Puy-de-Dôme",
      "64": "Pyrénées-Atlantiques",
      "65": "Hautes-Pyrénées",
      "66": "Pyrénées-Orientales",
      "67": "Bas-Rhin",
      "68": "Haut-Rhin",
      "69": "Rhône",
      "70": "Haute-Saône",
      "71": "Saône-et-Loire",
      "72": "Sarthe",
      "73": "Savoie",
      "74": "Haute-Savoie",
      "76": "Seine-Maritime",
      "77": "Seine-et-Marne",
      "78": "Yvelines",
      "79": "Deux-Sèvres",
      "80": "Somme",
      "81": "Tarn",
      "82": "Tarn-et-Garonne",
      "83": "Var",
      "84": "Vaucluse",
      "85": "Vendée",
      "86": "Vienne",
      "87": "Haute-Vienne",
      "88": "Vosges",
      "89": "Yonne",
      "90": "Territoire de Belfort",
      "91": "Essonne",
      "92": "Hauts-de-Seine",
      "93": "Seine-Saint-Denis",
      "94": "Val-de-Marne",
      "95": "Val-d'Oise",
      "971": "Guadeloupe",
      "972": "Martinique",
      "973": "French Guiana",
      "974": "La Réunion",
      "976": "Mayotte",
      "01": "Ain",
      "02": "Aisne",
      "03": "Allier",
      "04": "Alpes-de-Haute-Provence",
      "05": "Hautes-Alpes",
      "06": "Alpes-Maritimes",
      "07": "Ardèche",
      "08": "Ardennes",
      "09": "Ariège",
      "20R": "Corse",
      "2A": "Corse-du-Sud",
      "2B": "Haute-Corse",
      "69M": "Métropole de Lyon",
      "6AE": "Alsace",
      "75C": "Paris",
      ARA: "Auvergne-Rhône-Alpes",
      BFC: "Bourgogne-Franche-Comté",
      BL: "Saint-Barthélemy",
      BRE: "Bretagne",
      CP: "Clipperton",
      CVL: "Centre-Val de Loire",
      GES: "Grand-Est",
      HDF: "Hauts-de-France",
      IDF: "Île-de-France",
      MF: "Saint-Martin",
      NAQ: "Nouvelle-Aquitaine",
      NOR: "Normandie",
      OCC: "Occitanie",
      PAC: "Provence-Alpes-Côte-d’Azur",
      PDL: "Pays-de-la-Loire",
      PF: "French Polynesia",
      PM: "Saint Pierre and Miquelon",
      TF: "French Southern and Antarctic Lands",
      WF: "Wallis and Futuna",
    },
    GA: {
      "1": "Estuaire Province",
      "2": "Haut-Ogooué Province",
      "3": "Moyen-Ogooué Province",
      "4": "Ngounié Province",
      "5": "Nyanga Province",
      "6": "Ogooué-Ivindo Province",
      "7": "Ogooué-Lolo Province",
      "8": "Ogooué-Maritime Province",
      "9": "Woleu-Ntem Province",
    },
    GB: {
      ABC: "Armagh, Banbridge and Craigavon",
      ABD: "Aberdeenshire",
      ABE: "Aberdeen",
      AGB: "Argyll and Bute",
      AND: "Ards and North Down",
      ANN: "Antrim and Newtownabbey",
      ANS: "Angus",
      ANT: "Antrim",
      ARD: "Ards",
      ARM: "Armagh City and District Council",
      BAS: "Bath and North East Somerset",
      BBD: "Blackburn with Darwen",
      BDF: "Bedford",
      BDG: "London Borough of Barking and Dagenham",
      BEN: "London Borough of Brent",
      BEX: "London Borough of Bexley",
      BFS: "Belfast district",
      BGE: "Bridgend County Borough",
      BGW: "Blaenau Gwent County Borough",
      BIR: "Birmingham",
      BKM: "Buckinghamshire",
      BLA: "Ballymena Borough",
      BLY: "Ballymoney",
      BMH: "Bournemouth",
      BNB: "Banbridge",
      BNE: "London Borough of Barnet",
      BNH: "Brighton and Hove",
      BNS: "Barnsley",
      BOL: "Bolton",
      BPL: "Blackpool",
      BRC: "Bracknell Forest",
      BRD: "Bradford",
      BRY: "London Borough of Bromley",
      BST: "City of Bristol",
      BUR: "Bury",
      CAM: "Cambridgeshire",
      CAY: "Caerphilly County Borough",
      CBF: "Central Bedfordshire",
      CCG: "Causeway Coast and Glens",
      CGN: "Ceredigion",
      CGV: "Craigavon Borough Council",
      CHE: "Cheshire East",
      CHW: "Cheshire West and Chester",
      CKF: "Carrickfergus Borough Council",
      CKT: "Cookstown District Council",
      CLD: "Calderdale",
      CLK: "Clackmannanshire",
      CLR: "Coleraine Borough Council",
      CMA: "Cumbria",
      CMD: "London Borough of Camden",
      CMN: "Carmarthenshire",
      CON: "Cornwall",
      COV: "Coventry",
      CRF: "City and County of Cardiff",
      CRY: "London Borough of Croydon",
      CSR: "Castlereagh",
      CWY: "Conwy County Borough",
      DAL: "Darlington",
      DBY: "Derbyshire",
      DEN: "Denbighshire",
      DER: "City of Derby",
      DEV: "Devon",
      DGN: "Dungannon and South Tyrone Borough Council",
      DGY: "Dumfries and Galloway",
      DNC: "Doncaster",
      DND: "Dundee",
      DOR: "Dorset",
      DOW: "Down District Council",
      DRS: "Derry City and Strabane",
      DRY: "Derry City Council",
      DUD: "Dudley",
      DUR: "County Durham",
      EAL: "London Borough of Ealing",
      EAY: "East Ayrshire",
      EDH: "Edinburgh",
      EDU: "East Dunbartonshire",
      ELN: "East Lothian",
      ELS: "Outer Hebrides",
      ENF: "London Borough of Enfield",
      ENG: "England",
      ERW: "East Renfrewshire",
      ERY: "East Riding of Yorkshire",
      ESS: "Essex",
      ESX: "East Sussex",
      FAL: "Falkirk",
      FER: "Fermanagh District Council",
      FIF: "Fife",
      FLN: "Flintshire",
      FMO: "Fermanagh and Omagh",
      GAT: "Gateshead",
      GLG: "Glasgow",
      GLS: "Gloucestershire",
      GRE: "Royal Borough of Greenwich",
      GWN: "Gwynedd",
      HAL: "Halton",
      HAM: "Hampshire",
      HAV: "London Borough of Havering",
      HCK: "London Borough of Hackney",
      HEF: "Herefordshire",
      HIL: "London Borough of Hillingdon",
      HLD: "Highland",
      HMF: "London Borough of Hammersmith and Fulham",
      HNS: "London Borough of Hounslow",
      HPL: "Hartlepool",
      HRT: "Hertfordshire",
      HRW: "London Borough of Harrow",
      HRY: "London Borough of Haringey",
      IOS: "Isles of Scilly",
      IOW: "Isle of Wight",
      ISL: "London Borough of Islington",
      IVC: "Inverclyde",
      KEC: "Royal Borough of Kensington and Chelsea",
      KEN: "Kent",
      KHL: "City of Kingston upon Hull",
      KIR: "Kirklees",
      KTT: "Royal Borough of Kingston upon Thames",
      KWL: "Knowsley",
      LAN: "Lancashire",
      LBC: "Lisburn and Castlereagh",
      LBH: "London Borough of Lambeth",
      LCE: "City of Leicester",
      LDS: "Leeds",
      LEC: "Leicestershire",
      LEW: "London Borough of Lewisham",
      LIN: "Lincolnshire",
      LIV: "Liverpool",
      LMV: "Limavady Borough Council",
      LND: "City of London",
      LRN: "Larne Borough Council",
      LSB: "Lisburn City Council",
      MAN: "Manchester",
      MDB: "Middlesbrough",
      MDW: "Medway",
      MEA: "Mid and East Antrim",
      MFT: "Magherafelt District Council",
      MIK: "Milton Keynes",
      MLN: "Midlothian",
      MON: "Monmouthshire",
      MRT: "London Borough of Merton",
      MRY: "Moray",
      MTY: "Merthyr Tydfil County Borough",
      MUL: "Mid Ulster",
      MYL: "Moyle District Council",
      NAY: "North Ayrshire",
      NBL: "Northumberland",
      NDN: "North Down Borough Council",
      NEL: "North East Lincolnshire",
      NET: "Newcastle upon Tyne",
      NFK: "Norfolk",
      NGM: "City of Nottingham",
      NIR: "Northern Ireland",
      NLK: "North Lanarkshire",
      NLN: "North Lincolnshire",
      NMD: "Newry, Mourne and Down",
      NSM: "North Somerset",
      NTA: "Newtownabbey Borough Council",
      NTH: "Northamptonshire",
      NTL: "Neath Port Talbot County Borough",
      NTT: "Nottinghamshire",
      NTY: "North Tyneside",
      NWM: "London Borough of Newham",
      NWP: "Newport",
      NYK: "North Yorkshire",
      NYM: "Newry and Mourne District Council",
      OLD: "Oldham",
      OMH: "Omagh District Council",
      ORK: "Orkney Islands",
      OXF: "Oxfordshire",
      PEM: "Pembrokeshire",
      PKN: "Perth and Kinross",
      PLY: "City of Plymouth",
      POL: "Poole",
      POR: "City of Portsmouth",
      POW: "Powys",
      PTE: "City of Peterborough",
      RCC: "Redcar and Cleveland",
      RCH: "Rochdale",
      RCT: "Rhondda Cynon Taf",
      RDB: "London Borough of Redbridge",
      RDG: "Reading",
      RFW: "Renfrewshire",
      RIC: "London Borough of Richmond upon Thames",
      ROT: "Rotherham",
      RUT: "Rutland",
      SAW: "Sandwell",
      SAY: "South Ayrshire",
      SCB: "Scottish Borders",
      SCT: "Scotland",
      SFK: "Suffolk",
      SFT: "Sefton",
      SGC: "South Gloucestershire",
      "SH-AC": "Ascension Island",
      "SH-HL": "Saint Helena",
      SHF: "Sheffield",
      SHN: "St Helens",
      SHR: "Shropshire",
      SKP: "Stockport",
      SLF: "Salford",
      SLG: "Slough",
      SLK: "South Lanarkshire",
      SND: "City of Sunderland",
      SOL: "Solihull",
      SOM: "Somerset",
      SOS: "Southend-on-Sea",
      SRY: "Surrey",
      STB: "Strabane District Council",
      STE: "City of Stoke-on-Trent",
      STG: "Stirling",
      STH: "City of Southampton",
      STN: "London Borough of Sutton",
      STS: "Staffordshire",
      STT: "Stockton-on-Tees",
      STY: "South Tyneside",
      SWA: "City and County of Swansea",
      SWD: "Swindon",
      SWK: "London Borough of Southwark",
      TAM: "Tameside",
      TFW: "Telford and Wrekin",
      THR: "Thurrock",
      TOB: "Torbay",
      TOF: "Torfaen",
      TRF: "Trafford",
      TWH: "London Borough of Tower Hamlets",
      UKM: "United Kingdom",
      VGL: "Vale of Glamorgan",
      WAR: "Warwickshire",
      WBK: "West Berkshire",
      WDU: "West Dunbartonshire",
      WFT: "London Borough of Waltham Forest",
      WGN: "Metropolitan Borough of Wigan",
      WIL: "Wiltshire",
      WKF: "Wakefield",
      WLL: "Walsall",
      WLN: "West Lothian",
      WLS: "Wales",
      WLV: "City of Wolverhampton",
      WND: "London Borough of Wandsworth",
      WNM: "Windsor and Maidenhead",
      WOK: "Wokingham",
      WOR: "Worcestershire",
      WRL: "Wirral",
      WRT: "Warrington",
      WRX: "Wrexham County Borough",
      WSM: "City of Westminster",
      WSX: "West Sussex",
      YOR: "City of York",
      ZET: "Shetland Islands",
    },
    GD: {
      "10": "Carriacou and Petite Martinique",
      "01": "Saint Andrew Parish",
      "02": "Saint David Parish",
      "03": "Saint George Parish",
      "04": "Saint John Parish",
      "05": "Saint Mark Parish",
      "06": "Saint Patrick Parish",
    },
    GE: {
      "29": "Khelvachauri Municipality",
      "50": "Senaki Municipality",
      AB: "Autonomous Republic of Abkhazia",
      AJ: "Adjara",
      GU: "Guria",
      IM: "Imereti",
      KA: "Kakheti",
      KK: "Kvemo Kartli",
      MM: "Mtskheta-Mtianeti",
      RL: "Racha-Lechkhumi and Kvemo Svaneti",
      SJ: "Samtskhe-Javakheti",
      SK: "Shida Kartli",
      SZ: "Samegrelo-Zemo Svaneti",
      TB: "Tbilisi",
    },
    GH: {
      AA: "Greater Accra",
      AF: "Ahafo",
      AH: "Ashanti",
      BE: "Bono East",
      BO: "Bono",
      CP: "Central",
      EP: "Eastern",
      NE: "North East",
      NP: "Northern",
      OT: "Oti",
      SV: "Savannah",
      TV: "Volta",
      UE: "Upper East",
      UW: "Upper West",
      WN: "Western North",
      WP: "Western",
    },
    GM: {
      B: "Banjul",
      L: "Lower River Division",
      M: "Central River Division",
      N: "North Bank Division",
      U: "Upper River Division",
      W: "West Coast Division",
    },
    GN: {
      B: "Boké Region",
      BE: "Beyla Prefecture",
      BF: "Boffa Prefecture",
      BK: "Boké Prefecture",
      C: "Conakry",
      CO: "Coyah Prefecture",
      D: "Kindia Region",
      DB: "Dabola Prefecture",
      DI: "Dinguiraye Prefecture",
      DL: "Dalaba Prefecture",
      DU: "Dubréka Prefecture",
      FA: "Faranah Prefecture",
      FO: "Forécariah Prefecture",
      FR: "Fria Prefecture",
      GA: "Gaoual Prefecture",
      GU: "Guéckédou Prefecture",
      K: "Kankan Region",
      KA: "Kankan Prefecture",
      KB: "Koubia Prefecture",
      KD: "Kindia Prefecture",
      KE: "Kérouané Prefecture",
      KN: "Koundara Prefecture",
      KO: "Kouroussa Prefecture",
      KS: "Kissidougou Prefecture",
      L: "Labé Region",
      LA: "Labé Prefecture",
      LE: "Lélouma Prefecture",
      LO: "Lola Prefecture",
      M: "Mamou Region",
      MC: "Macenta Prefecture",
      MD: "Mandiana Prefecture",
      ML: "Mali Prefecture",
      MM: "Mamou Prefecture",
      N: "Nzérékoré Region",
      NZ: "Nzérékoré Prefecture",
      PI: "Pita Prefecture",
      SI: "Siguiri Prefecture",
      TE: "Télimélé Prefecture",
      TO: "Tougué Prefecture",
      YO: "Yomou Prefecture",
    },
    GQ: {
      AN: "Annobón Province",
      BN: "Bioko Norte Province",
      BS: "Bioko Sur Province",
      C: "Río Muni",
      CS: "Centro Sur Province",
      I: "Insular Region",
      KN: "Kié-Ntem Province",
      LI: "Litoral Province",
      WN: "Wele-Nzas Province",
    },
    GR: {
      "11": "Argolis Regional Unit",
      "12": "Arcadia Prefecture",
      "13": "Achaea Regional Unit",
      "15": "Corinthia Regional Unit",
      "16": "Laconia",
      "22": "Corfu Prefecture",
      "23": "Kefalonia Prefecture",
      "24": "Lefkada Regional Unit",
      "33": "Ioannina Regional Unit",
      "34": "Preveza Prefecture",
      "41": "Karditsa Regional Unit",
      "42": "Larissa Prefecture",
      "51": "Grevena Prefecture",
      "52": "Drama Regional Unit",
      "53": "Imathia Regional Unit",
      "54": "Thessaloniki Regional Unit",
      "56": "Kastoria Regional Unit",
      "57": "Kilkis Regional Unit",
      "58": "Kozani Prefecture",
      "59": "Pella Regional Unit",
      "62": "Serres Prefecture",
      "94": "Chania Regional Unit",
      "01": "Aetolia-Acarnania Regional Unit",
      "03": "Boeotia Regional Unit",
      "04": "Euboea",
      "06": "Phthiotis Prefecture",
      A: "East Macedonia and Thrace",
      A2: "East Attica Regional Unit",
      B: "Central Macedonia",
      C: "West Macedonia Region",
      D: "Epirus Region",
      F: "Ionian Islands Region",
      G: "West Greece Region",
      H: "Central Greece Region",
      I: "Attica Region",
      J: "Peloponnese Region",
      L: "South Aegean",
      M: "Crete Region",
    },
    GT: {
      AV: "Alta Verapaz Department",
      BV: "Baja Verapaz Department",
      CM: "Chimaltenango Department",
      CQ: "Chiquimula Department",
      ES: "Escuintla Department",
      GU: "Guatemala Department",
      HU: "Huehuetenango Department",
      IZ: "Izabal Department",
      JA: "Jalapa Department",
      JU: "Jutiapa Department",
      PE: "Petén Department",
      PR: "El Progreso Department",
      QC: "Quiché Department",
      QZ: "Quetzaltenango Department",
      RE: "Retalhuleu Department",
      SA: "Sacatepéquez Department",
      SM: "San Marcos Department",
      SO: "Sololá Department",
      SR: "Santa Rosa Department",
      SU: "Suchitepéquez Department",
      TO: "Totonicapán Department",
    },
    GW: {
      BA: "Bafatá",
      BL: "Bolama Region",
      BM: "Biombo Region",
      CA: "Cacheu Region",
      GA: "Gabú Region",
      L: "Leste Province",
      N: "Norte Province",
      OI: "Oio Region",
      QU: "Quinara Region",
      S: "Sul Province",
      TO: "Tombali Region",
    },
    GY: {
      BA: "Barima-Waini",
      CU: "Cuyuni-Mazaruni",
      DE: "Demerara-Mahaica",
      EB: "East Berbice-Corentyne",
      ES: "Essequibo Islands-West Demerara",
      MA: "Mahaica-Berbice",
      PM: "Pomeroon-Supenaam",
      PT: "Potaro-Siparuni",
      UD: "Upper Demerara-Berbice",
      UT: "Upper Takutu-Upper Essequibo",
    },
    HK: {
      HCW: "Central and Western District",
      HEA: "Eastern",
      HSO: "Southern",
      HWC: "Wan Chai",
      KKC: "Kowloon City",
      KKT: "Kwun Tong",
      KSS: "Sham Shui Po",
      KWT: "Wong Tai Sin",
      KYT: "Yau Tsim Mong",
      NIS: "Islands District",
      NKT: "Kwai Tsing",
      NNO: "North",
      NSK: "Sai Kung District",
      NST: "Sha Tin",
      NTM: "Tuen Mun",
      NTW: "Tsuen Wan District",
      NYL: "Yuen Long District",
    },
    HN: {
      AT: "Atlántida Department",
      CH: "Choluteca Department",
      CL: "Colón Department",
      CM: "Comayagua Department",
      CP: "Copán Department",
      CR: "Cortés Department",
      EP: "El Paraíso Department",
      FM: "Francisco Morazán Department",
      GD: "Gracias a Dios Department",
      IB: "Bay Islands Department",
      IN: "Intibucá Department",
      LE: "Lempira Department",
      LP: "La Paz Department",
      OC: "Ocotepeque Department",
      OL: "Olancho Department",
      SB: "Santa Bárbara Department",
      VA: "Valle Department",
      YO: "Yoro Department",
    },
    HR: {
      "10": "Virovitica-Podravina County",
      "11": "Požega-Slavonia County",
      "12": "Brod-Posavina County",
      "13": "Zadar County",
      "14": "Osijek-Baranja County",
      "15": "Šibenik-Knin County",
      "16": "Vukovar-Syrmia County",
      "17": "Split-Dalmatia County",
      "18": "Istria County",
      "19": "Dubrovnik-Neretva County",
      "20": "Međimurje County",
      "21": "Zagreb",
      "01": "Zagreb County",
      "02": "Krapina-Zagorje County",
      "03": "Sisak-Moslavina County",
      "05": "Karlovac County",
      "06": "Koprivnica-Križevci County",
      "07": "Bjelovar-Bilogora County",
      "08": "Primorje-Gorski Kotar County",
      "09": "Lika-Senj County",
    },
    HT: {
      AR: "Artibonite",
      CE: "Centre",
      GA: "Grand'Anse",
      ND: "Nord",
      NE: "Nord-Est",
      NI: "Nippes",
      NO: "Nord-Ouest",
      OU: "Ouest",
      SD: "Sud",
      SE: "Sud-Est",
    },
    HU: {
      BA: "Baranya County",
      BC: "Békéscsaba",
      BE: "Békés County",
      BK: "Bács-Kiskun County",
      BU: "Budapest",
      BZ: "Borsod-Abaúj-Zemplén County",
      CS: "Csongrád County",
      DE: "Debrecen",
      DU: "Dunaújváros",
      EG: "Eger",
      ER: "Érd",
      FE: "Fejér County",
      GS: "Győr-Moson-Sopron County",
      GY: "Győr",
      HB: "Hajdú-Bihar County",
      HE: "Heves County",
      HV: "Hódmezővásárhely",
      JN: "Jász-Nagykun-Szolnok County",
      KM: "Kecskemét",
      KV: "Kaposvár",
      MI: "Miskolc",
      NK: "Nagykanizsa",
      NO: "Nógrád County",
      NY: "Nyíregyháza",
      PE: "Pest County",
      PS: "Pécs",
      SD: "Szeged",
      SF: "Székesfehérvár",
      SH: "Szombathely",
      SK: "Szolnok",
      SN: "Sopron",
      SO: "Somogy County",
      SS: "Szekszárd",
      ST: "Salgótarján",
      SZ: "Szabolcs-Szatmár-Bereg County",
      TB: "Tatabánya",
      TO: "Tolna County",
      VA: "Vas County",
      VE: "Veszprém County",
      VM: "Veszprém",
      ZA: "Zala County",
      ZE: "Zalaegerszeg",
    },
    ID: {
      AC: "Aceh",
      BA: "Bali",
      BB: "Kepulauan Bangka Belitung",
      BE: "Bengkulu",
      BT: "Banten",
      GO: "Gorontalo",
      JA: "Jambi",
      JB: "Jawa Barat",
      JI: "Jawa Timur",
      JK: "DKI Jakarta",
      JT: "Jawa Tengah",
      KA: "Kalimantan Barat",
      KI: "Kalimantan Timur",
      KR: "Kepulauan Riau",
      KS: "Kalimantan Selatan",
      KT: "Kalimantan Tengah",
      KU: "Kalimantan Utara",
      LA: "Lampung",
      MA: "Maluku",
      MU: "Maluku Utara",
      NB: "Nusa Tenggara Barat",
      NT: "Nusa Tenggara Timur",
      PA: "Papua",
      PB: "Papua Barat",
      RI: "Riau",
      SA: "Sulawesi Utara",
      SB: "Sumatera Barat",
      SG: "Sulawesi Tenggara",
      SN: "Sulawesi Selatan",
      SR: "Sulawesi Barat",
      SS: "Sumatera Selatan",
      ST: "Sulawesi Tengah",
      SU: "Sumatera Utara",
      YO: "DI Yogyakarta",
    },
    IE: {
      C: "Connacht",
      CE: "Clare",
      CN: "Cavan",
      CO: "Cork",
      CW: "Carlow",
      D: "Dublin",
      DL: "Donegal",
      G: "Galway",
      KE: "Kildare",
      KK: "Kilkenny",
      KY: "Kerry",
      L: "Leinster",
      LD: "Longford",
      LH: "Louth",
      LK: "Limerick",
      LS: "Laois",
      M: "Munster",
      MH: "Meath",
      MN: "Monaghan",
      MO: "Mayo",
      OY: "Offaly",
      RN: "Roscommon",
      SO: "Sligo",
      TA: "Tipperary",
      U: "Ulster",
      WD: "Waterford",
      WH: "Westmeath",
      WW: "Wicklow",
      WX: "Wexford",
    },
    IL: {
      D: "Southern District",
      HA: "Haifa District",
      JM: "Jerusalem District",
      M: "Central District",
      TA: "Tel Aviv District",
      Z: "Northern District",
    },
    IN: {
      AN: "Andaman and Nicobar Islands",
      AP: "Andhra Pradesh",
      AR: "Arunachal Pradesh",
      AS: "Assam",
      BR: "Bihar",
      CH: "Chandigarh",
      CT: "Chhattisgarh",
      DH: "Dadra and Nagar Haveli and Daman and Diu",
      DL: "Delhi",
      GA: "Goa",
      GJ: "Gujarat",
      HP: "Himachal Pradesh",
      HR: "Haryana",
      JH: "Jharkhand",
      JK: "Jammu and Kashmir",
      KA: "Karnataka",
      KL: "Kerala",
      LA: "Ladakh",
      LD: "Lakshadweep",
      MH: "Maharashtra",
      ML: "Meghalaya",
      MN: "Manipur",
      MP: "Madhya Pradesh",
      MZ: "Mizoram",
      NL: "Nagaland",
      OR: "Odisha",
      PB: "Punjab",
      PY: "Puducherry",
      RJ: "Rajasthan",
      SK: "Sikkim",
      TG: "Telangana",
      TN: "Tamil Nadu",
      TR: "Tripura",
      UP: "Uttar Pradesh",
      UT: "Uttarakhand",
      WB: "West Bengal",
    },
    IQ: {
      AN: "Al Anbar Governorate",
      AR: "Erbil Governorate",
      BA: "Basra Governorate",
      BB: "Babylon Governorate",
      BG: "Baghdad Governorate",
      DA: "Dohuk Governorate",
      DI: "Diyala Governorate",
      DQ: "Dhi Qar Governorate",
      KA: "Karbala Governorate",
      KI: "Kirkuk Governorate",
      MA: "Maysan Governorate",
      MU: "Al Muthanna Governorate",
      NA: "Najaf Governorate",
      NI: "Nineveh Governorate",
      QA: "Al-Qādisiyyah Governorate",
      SD: "Saladin Governorate",
      SU: "Sulaymaniyah Governorate",
      WA: "Wasit Governorate",
    },
    IR: {
      "10": "Isfahan",
      "11": "Sistan and Baluchestan",
      "12": "Kurdistan",
      "13": "Hamadan",
      "14": "Chaharmahal and Bakhtiari",
      "15": "Lorestan",
      "16": "Ilam",
      "17": "Kohgiluyeh and Boyer-Ahmad",
      "18": "Bushehr",
      "19": "Zanjan",
      "20": "Semnan",
      "21": "Yazd",
      "22": "Hormozgan",
      "23": "Tehran",
      "24": "Ardabil",
      "25": "Qom",
      "26": "Qazvin",
      "27": "Golestan",
      "28": "North Khorasan",
      "29": "South Khorasan",
      "30": "Alborz",
      "00": "Markazi",
      "01": "Gilan",
      "02": "Mazandaran",
      "03": "East Azerbaijan",
      "04": "West Azarbaijan",
      "05": "Kermanshah",
      "06": "Khuzestan",
      "07": "Fars",
      "08": "Kerman",
      "09": "Razavi Khorasan",
    },
    IS: {
      "1": "Capital Region",
      "2": "Southern Peninsula Region",
      "3": "Western Region",
      "4": "Westfjords",
      "5": "Northwestern Region",
      "6": "Northeastern Region",
      "7": "Eastern Region",
      "8": "Southern Region",
    },
    IT: {
      "21": "Piedmont",
      "23": "Aosta Valley",
      "25": "Lombardy",
      "32": "Trentino-South Tyrol",
      "34": "Veneto",
      "36": "Friuli–Venezia Giulia",
      "42": "Liguria",
      "45": "Emilia-Romagna",
      "52": "Tuscany",
      "55": "Umbria",
      "57": "Marche",
      "62": "Lazio",
      "65": "Abruzzo",
      "67": "Molise",
      "72": "Campania",
      "75": "Apulia",
      "77": "Basilicata",
      "78": "Calabria",
      "82": "Sicily",
      "88": "Sardinia",
      AG: "Libero consorzio comunale di Agrigento",
      AL: "Province of Alessandria",
      AN: "Province of Ancona",
      AP: "Province of Ascoli Piceno",
      AQ: "Province of L'Aquila",
      AT: "Province of Asti",
      AV: "Province of Avellino",
      BA: "Metropolitan City of Bari",
      BG: "Province of Bergamo",
      BI: "Province of Biella",
      BL: "Province of Belluno",
      BN: "Benevento Province",
      BO: "Metropolitan City of Bologna",
      BR: "Province of Brindisi",
      BS: "Province of Brescia",
      BT: "Province of Barletta-Andria-Trani",
      BZ: "South Tyrol",
      CA: "Metropolitan City of Cagliari",
      CB: "Province of Campobasso",
      CE: "Province of Caserta",
      CH: "Province of Chieti",
      CI: "Province of Carbonia-Iglesias",
      CL: "Libero consorzio comunale di Caltanissetta",
      CN: "Province of Cuneo",
      CO: "Province of Como",
      CR: "Province of Cremona",
      CS: "Province of Cosenza",
      CT: "Metropolitan City of Catania",
      CZ: "Province of Catanzaro",
      EN: "Libero consorzio comunale di Enna",
      FC: "Province of Forlì-Cesena",
      FE: "Province of Ferrara",
      FG: "Province of Foggia",
      FI: "Metropolitan City of Florence",
      FM: "Province of Fermo",
      FR: "Province of Frosinone",
      GE: "Metropolitan City of Genoa",
      GO: "Province of Gorizia",
      GR: "Province of Grosseto",
      IM: "Province of Imperia",
      IS: "Province of Isernia",
      KR: "Province of Crotone",
      LC: "Province of Lecco",
      LE: "Province of Lecce",
      LI: "Province of Livorno",
      LO: "Province of Lodi",
      LT: "Province of Latina",
      LU: "Province of Lucca",
      MB: "Province of Monza and Brianza",
      MC: "Province of Macerata",
      ME: "Metropolitan City of Messina",
      MI: "Metropolitan City of Milan",
      MN: "Province of Mantua",
      MO: "Province of Modena",
      MS: "Province of Massa and Carrara",
      MT: "Province of Matera",
      NA: "Metropolitan City of Naples",
      NO: "Province of Novara",
      NU: "Province of Nuoro",
      OG: "Province of Ogliastra",
      OR: "Province of Oristano",
      OT: "Province of Olbia-Tempio",
      PA: "Metropolitan City of Palermo",
      PC: "Province of Piacenza",
      PD: "Province of Padua",
      PE: "Province of Pescara",
      PG: "Province of Perugia",
      PI: "Province of Pisa",
      PN: "Province of Pordenone",
      PO: "Province of Prato",
      PR: "Province of Parma",
      PT: "Province of Pistoia",
      PU: "Pesaro and Urbino Province",
      PV: "Province of Pavia",
      PZ: "Province of Potenza",
      RA: "Province of Ravenna",
      RC: "Metropolitan City of Reggio Calabria",
      RE: "Province of Reggio Emilia",
      RG: "Libero consorzio comunale di Ragusa",
      RI: "Province of Rieti",
      RM: "Metropolitan City of Rome",
      RN: "Province of Rimini",
      RO: "Province of Rovigo",
      SA: "Province of Salerno",
      SI: "Province of Siena",
      SO: "Province of Sondrio",
      SP: "Province of La Spezia",
      SR: "Libero consorzio comunale di Siracusa",
      SS: "Province of Sassari",
      SV: "Province of Savona",
      TA: "Province of Taranto",
      TE: "Province of Teramo",
      TN: "Trentino",
      TO: "Metropolitan City of Turin",
      TP: "Libero consorzio comunale di Trapani",
      TR: "Province of Terni",
      TS: "Province of Trieste",
      TV: "Province of Treviso",
      UD: "Province of Udine",
      VA: "Province of Varese",
      VB: "Province of Verbano-Cusio-Ossola",
      VC: "Province of Vercelli",
      VE: "Metropolitan City of Venice",
      VI: "Province of Vicenza",
      VR: "Province of Verona",
      VS: "Province of Medio Campidano",
      VT: "Province of Viterbo",
      VV: "Province of Vibo Valentia",
    },
    JM: {
      "10": "Westmoreland Parish",
      "11": "Saint Elizabeth Parish",
      "12": "Manchester Parish",
      "13": "Clarendon Parish",
      "14": "Saint Catherine Parish",
      "01": "Kingston Parish",
      "02": "Saint Andrew",
      "03": "Saint Thomas Parish",
      "04": "Portland Parish",
      "05": "Saint Mary Parish",
      "06": "Saint Ann Parish",
      "07": "Trelawny Parish",
      "08": "Saint James Parish",
      "09": "Hanover Parish",
    },
    JO: {
      AJ: "Ajloun Governorate",
      AM: "Amman Governorate",
      AQ: "Aqaba Governorate",
      AT: "Tafilah Governorate",
      AZ: "Zarqa Governorate",
      BA: "Balqa Governorate",
      IR: "Irbid Governorate",
      JA: "Jerash Governorate",
      KA: "Karak Governorate",
      MA: "Mafraq Governorate",
      MD: "Madaba Governorate",
      MN: "Ma'an Governorate",
    },
    JP: {
      "10": "Gunma Prefecture",
      "11": "Saitama Prefecture",
      "12": "Chiba Prefecture",
      "13": "Tokyo",
      "14": "Kanagawa Prefecture",
      "15": "Niigata Prefecture",
      "16": "Toyama Prefecture",
      "17": "Ishikawa Prefecture",
      "18": "Fukui Prefecture",
      "19": "Yamanashi Prefecture",
      "20": "Nagano Prefecture",
      "21": "Gifu Prefecture",
      "22": "Shizuoka Prefecture",
      "23": "Aichi Prefecture",
      "24": "Mie Prefecture",
      "25": "Shiga Prefecture",
      "26": "Kyōto Prefecture",
      "27": "Ōsaka Prefecture",
      "28": "Hyōgo Prefecture",
      "29": "Nara Prefecture",
      "30": "Wakayama Prefecture",
      "31": "Tottori Prefecture",
      "32": "Shimane Prefecture",
      "33": "Okayama Prefecture",
      "34": "Hiroshima Prefecture",
      "35": "Yamaguchi Prefecture",
      "36": "Tokushima Prefecture",
      "37": "Kagawa Prefecture",
      "38": "Ehime Prefecture",
      "39": "Kōchi Prefecture",
      "40": "Fukuoka Prefecture",
      "41": "Saga Prefecture",
      "42": "Nagasaki Prefecture",
      "43": "Kumamoto Prefecture",
      "44": "Ōita Prefecture",
      "45": "Miyazaki Prefecture",
      "46": "Kagoshima Prefecture",
      "47": "Okinawa Prefecture",
      "01": "Hokkaidō Prefecture",
      "02": "Aomori Prefecture",
      "03": "Iwate Prefecture",
      "04": "Miyagi Prefecture",
      "05": "Akita Prefecture",
      "06": "Yamagata Prefecture",
      "07": "Fukushima Prefecture",
      "08": "Ibaraki Prefecture",
      "09": "Tochigi Prefecture",
    },
    KE: {
      "10": "Kajiado",
      "11": "Kakamega",
      "12": "Kericho",
      "13": "Kiambu",
      "14": "Kilifi",
      "15": "Kirinyaga",
      "16": "Kisii",
      "17": "Kisumu",
      "18": "Kitui",
      "19": "Kwale",
      "20": "Laikipia",
      "21": "Lamu",
      "22": "Machakos",
      "23": "Makueni",
      "24": "Mandera",
      "25": "Marsabit",
      "26": "Meru",
      "27": "Migori",
      "28": "Mombasa",
      "29": "Murang'a",
      "30": "Nairobi City",
      "31": "Nakuru",
      "32": "Nandi",
      "33": "Narok",
      "34": "Nyamira",
      "35": "Nyandarua",
      "36": "Nyeri",
      "37": "Samburu",
      "38": "Siaya",
      "39": "Taita–Taveta",
      "40": "Tana River",
      "41": "Tharaka-Nithi",
      "42": "Trans Nzoia",
      "43": "Turkana",
      "44": "Uasin Gishu",
      "45": "Vihiga",
      "46": "Wajir",
      "47": "West Pokot",
      "01": "Baringo",
      "02": "Bomet",
      "03": "Bungoma",
      "04": "Busia",
      "05": "Elgeyo-Marakwet",
      "06": "Embu",
      "07": "Garissa",
      "08": "Homa Bay",
      "09": "Isiolo",
    },
    KG: {
      B: "Batken Region",
      C: "Chuy Region",
      GB: "Bishkek",
      GO: "Osh",
      J: "Jalal-Abad Region",
      N: "Naryn Region",
      O: "Osh Region",
      T: "Talas Region",
      Y: "Issyk-Kul Region",
    },
    KH: {
      "1": "Banteay Meanchey",
      "2": "Battambang",
      "3": "Kampong Cham",
      "4": "Kampong Chhnang",
      "5": "Kampong Speu",
      "6": "Kampong Thom",
      "7": "Kampot",
      "8": "Kandal",
      "9": "Koh Kong",
      "10": "Kratie",
      "11": "Mondulkiri",
      "12": "Phnom Penh",
      "13": "Preah Vihear",
      "14": "Prey Veng",
      "15": "Pursat",
      "16": "Ratanakiri",
      "17": "Siem Reap",
      "18": "Sihanoukville",
      "19": "Stung Treng",
      "20": "Svay Rieng",
      "21": "Takeo",
      "22": "Oddar Meanchey",
      "23": "Kep",
      "24": "Pailin",
      NTP: "Tai Po District",
    },
    KI: {
      G: "Gilbert Islands",
      L: "Line Islands",
      P: "Phoenix Islands",
    },
    KM: {
      A: "Anjouan",
      G: "Grande Comore",
      M: "Mohéli",
    },
    KN: {
      "10": "Saint Paul Charlestown Parish",
      "11": "Saint Peter Basseterre Parish",
      "12": "Saint Thomas Lowland Parish",
      "13": "Saint Thomas Middle Island Parish",
      "15": "Trinity Palmetto Point Parish",
      "01": "Christ Church Nichola Town Parish",
      "02": "Saint Anne Sandy Point Parish",
      "04": "Saint George Gingerland Parish",
      "05": "Saint James Windward Parish",
      "06": "Saint John Capisterre Parish",
      "07": "Saint John Figtree Parish",
      "08": "Saint Mary Cayon Parish",
      "09": "Saint Paul Capisterre Parish",
      K: "Saint Kitts",
      N: "Nevis",
    },
    KP: {
      "10": "Ryanggang Province",
      "13": "Rason",
      "01": "Pyongyang",
      "02": "South Pyongan Province",
      "03": "North Pyongan Province",
      "04": "Chagang Province",
      "05": "South Hwanghae Province",
      "06": "North Hwanghae Province",
      "07": "Kangwon Province",
      "08": "South Hamgyong Province",
      "09": "North Hamgyong Province",
    },
    KR: {
      "11": "Seoul",
      "26": "Busan",
      "27": "Daegu",
      "28": "Incheon",
      "29": "Gwangju",
      "30": "Daejeon",
      "31": "Ulsan",
      "41": "Gyeonggi Province",
      "42": "Gangwon Province",
      "43": "North Chungcheong Province",
      "44": "South Chungcheong Province",
      "45": "North Jeolla Province",
      "46": "South Jeolla Province",
      "47": "North Gyeongsang Province",
      "48": "South Gyeongsang Province",
      "49": "Jeju",
      "50": "Sejong City",
    },
    KW: {
      AH: "Al Ahmadi Governorate",
      FA: "Al Farwaniyah Governorate",
      HA: "Hawalli Governorate",
      JA: "Al Jahra Governorate",
      KU: "Capital Governorate",
      MU: "Mubarak Al-Kabeer Governorate",
    },
    KZ: {
      AKM: "Akmola Region",
      AKT: "Aktobe Region",
      ALA: "Almaty",
      ALM: "Almaty Region",
      AST: "Nur-Sultan",
      ATY: "Atyrau Region",
      BAY: "Baikonur",
      KAR: "Karaganda Region",
      KUS: "Kostanay Region",
      KZY: "Kyzylorda Region",
      MAN: "Mangystau Region",
      PAV: "Pavlodar Region",
      SEV: "North Kazakhstan Region",
      VOS: "East Kazakhstan Region",
      YUZ: "Turkestan Region",
      ZAP: "West Kazakhstan Province",
      ZHA: "Jambyl Region",
    },
    LA: {
      AT: "Attapeu Province",
      BK: "Bokeo Province",
      BL: "Bolikhamsai Province",
      CH: "Champasak Province",
      HO: "Houaphanh Province",
      KH: "Khammouane Province",
      LM: "Luang Namtha Province",
      LP: "Luang Prabang Province",
      OU: "Oudomxay Province",
      PH: "Phongsaly Province",
      SL: "Salavan Province",
      SV: "Savannakhet Province",
      VI: "Vientiane Province",
      VT: "Vientiane Prefecture",
      XA: "Sainyabuli Province",
      XE: "Sekong Province",
      XI: "Xiangkhouang Province",
      XN: "Xaisomboun",
      XS: "Xaisomboun Province",
    },
    LB: {
      AK: "Akkar Governorate",
      AS: "North Governorate",
      BA: "Beirut Governorate",
      BH: "Baalbek-Hermel Governorate",
      BI: "Beqaa Governorate",
      JA: "South Governorate",
      JL: "Mount Lebanon Governorate",
      NA: "Nabatieh Governorate",
    },
    LC: {
      "10": "Soufrière Quarter",
      "11": "Vieux Fort Quarter",
      "12": "Canaries",
      "01": "Anse la Raye Quarter",
      "02": "Castries Quarter",
      "03": "Choiseul Quarter",
      "04": "Dauphin Quarter",
      "05": "Dennery Quarter",
      "06": "Gros Islet Quarter",
      "07": "Laborie Quarter",
      "08": "Micoud Quarter",
      "09": "Praslin Quarter",
    },
    LI: {
      "10": "Triesenberg",
      "11": "Vaduz",
      "01": "Balzers",
      "02": "Eschen",
      "03": "Gamprin",
      "04": "Mauren",
      "05": "Planken",
      "06": "Ruggell",
      "07": "Schaan",
      "08": "Schellenberg",
      "09": "Triesen",
    },
    LK: {
      "1": "Western Province",
      "2": "Central Province",
      "3": "Southern Province",
      "4": "Northern Province",
      "5": "Eastern Province",
      "6": "North Western Province",
      "7": "North Central Province",
      "8": "Uva Province",
      "9": "Sabaragamuwa Province",
      "11": "Colombo District",
      "12": "Gampaha District",
      "13": "Kalutara District",
      "21": "Kandy District",
      "22": "Matale District",
      "23": "Nuwara Eliya District",
      "31": "Galle District",
      "32": "Matara District",
      "33": "Hambantota District",
      "41": "Jaffna District",
      "42": "Kilinochchi District",
      "43": "Mannar District",
      "44": "Vavuniya District",
      "45": "Mullaitivu District",
      "51": "Batticaloa District",
      "52": "Ampara District",
      "53": "Trincomalee District",
      "62": "Puttalam District",
      "71": "Anuradhapura District",
      "72": "Polonnaruwa District",
      "81": "Badulla District",
      "82": "Monaragala District",
      "91": "Ratnapura district",
      "92": "Kegalle District",
    },
    LR: {
      BG: "Bong County",
      BM: "Bomi County",
      CM: "Grand Cape Mount County",
      GB: "Grand Bassa County",
      GG: "Grand Gedeh County",
      GK: "Grand Kru County",
      GP: "Gbarpolu County",
      LO: "Lofa County",
      MG: "Margibi County",
      MO: "Montserrado County",
      MY: "Maryland County",
      NI: "Nimba",
      RG: "River Gee County",
      RI: "River Cess County",
      SI: "Sinoe County",
    },
    LS: {
      A: "Maseru District",
      B: "Butha-Buthe District",
      C: "Leribe District",
      D: "Berea District",
      E: "Mafeteng District",
      F: "Mohale's Hoek District",
      G: "Quthing District",
      H: "Qacha's Nek District",
      J: "Mokhotlong District",
      K: "Thaba-Tseka District",
    },
    LT: {
      "10": "Jonava District Municipality",
      "11": "Joniškis District Municipality",
      "12": "Jurbarkas District Municipality",
      "13": "Kaišiadorys District Municipality",
      "14": "Kalvarija municipality",
      "15": "Kaunas City Municipality",
      "16": "Kaunas District Municipality",
      "17": "Kazlų Rūda municipality",
      "18": "Kėdainiai District Municipality",
      "19": "Kelmė District Municipality",
      "20": "Klaipeda City Municipality",
      "21": "Klaipėda District Municipality",
      "22": "Kretinga District Municipality",
      "23": "Kupiškis District Municipality",
      "24": "Lazdijai District Municipality",
      "25": "Marijampolė Municipality",
      "26": "Mažeikiai District Municipality",
      "27": "Molėtai District Municipality",
      "28": "Neringa Municipality",
      "29": "Pagėgiai municipality",
      "30": "Pakruojis District Municipality",
      "31": "Palanga City Municipality",
      "32": "Panevėžys City Municipality",
      "33": "Panevėžys District Municipality",
      "34": "Pasvalys District Municipality",
      "35": "Plungė District Municipality",
      "36": "Prienai District Municipality",
      "37": "Radviliškis District Municipality",
      "38": "Raseiniai District Municipality",
      "39": "Rietavas municipality",
      "40": "Rokiškis District Municipality",
      "41": "Šakiai District Municipality",
      "42": "Šalčininkai District Municipality",
      "43": "Šiauliai City Municipality",
      "44": "Šiauliai District Municipality",
      "45": "Šilalė District Municipality",
      "46": "Šilutė District Municipality",
      "47": "Širvintos District Municipality",
      "48": "Skuodas District Municipality",
      "49": "Švenčionys District Municipality",
      "50": "Tauragė District Municipality",
      "51": "Telšiai District Municipality",
      "52": "Trakai District Municipality",
      "53": "Ukmergė District Municipality",
      "54": "Utena District Municipality",
      "55": "Varėna District Municipality",
      "56": "Vilkaviškis District Municipality",
      "57": "Vilnius City Municipality",
      "58": "Vilnius District Municipality",
      "59": "Visaginas Municipality",
      "60": "Zarasai District Municipality",
      "01": "Akmenė District Municipality",
      "02": "Alytus City Municipality",
      "03": "Alytus District Municipality",
      "05": "Birštonas Municipality",
      "06": "Biržai District Municipality",
      "07": "Druskininkai municipality",
      "08": "Elektrėnai municipality",
      "09": "Ignalina District Municipality",
      AL: "Alytus County",
      KL: "Klaipėda County",
      KU: "Kaunas County",
      MR: "Marijampolė County",
      PN: "Panevėžys County",
      SA: "Šiauliai County",
      TA: "Tauragė County",
      TE: "Telšiai County",
      UT: "Utena County",
      VL: "Vilnius County",
    },
    LU: {
      CA: "Canton of Capellen",
      CL: "Canton of Clervaux",
      D: "Diekirch District",
      DI: "Canton of Diekirch",
      EC: "Canton of Echternach",
      ES: "Canton of Esch-sur-Alzette",
      G: "Grevenmacher District",
      GR: "Canton of Grevenmacher",
      L: "Luxembourg District",
      LU: "Canton of Luxembourg",
      ME: "Canton of Mersch",
      RD: "Canton of Redange",
      RM: "Canton of Remich",
      VD: "Canton of Vianden",
      WI: "Canton of Wiltz",
    },
    LV: {
      "100": "Vaiņode Municipality",
      "101": "Valka Municipality",
      "102": "Varakļāni Municipality",
      "103": "Vārkava Municipality",
      "104": "Vecpiebalga Municipality",
      "105": "Vecumnieki Municipality",
      "106": "Ventspils Municipality",
      "107": "Viesīte Municipality",
      "108": "Viļaka Municipality",
      "109": "Viļāni Municipality",
      "110": "Zilupe Municipality",
      "001": "Aglona Municipality",
      "002": "Aizkraukle Municipality",
      "003": "Aizpute Municipality",
      "004": "Aknīste Municipality",
      "005": "Aloja Municipality",
      "006": "Alsunga Municipality",
      "007": "Alūksne Municipality",
      "008": "Amata Municipality",
      "009": "Ape Municipality",
      "010": "Auce Municipality",
      "012": "Babīte Municipality",
      "013": "Baldone Municipality",
      "014": "Baltinava Municipality",
      "015": "Balvi Municipality",
      "016": "Bauska Municipality",
      "017": "Beverīna Municipality",
      "018": "Brocēni Municipality",
      "019": "Burtnieki Municipality",
      "020": "Carnikava Municipality",
      "021": "Cesvaine Municipality",
      "022": "Cēsis Municipality",
      "023": "Cibla Municipality",
      "024": "Dagda Municipality",
      "025": "Daugavpils Municipality",
      "026": "Dobele Municipality",
      "027": "Dundaga Municipality",
      "028": "Durbe Municipality",
      "029": "Engure Municipality",
      "030": "Ērgļi Municipality",
      "031": "Garkalne Municipality",
      "032": "Grobiņa Municipality",
      "033": "Gulbene Municipality",
      "034": "Iecava Municipality",
      "035": "Ikšķile Municipality",
      "036": "Ilūkste Municipality",
      "037": "Inčukalns Municipality",
      "038": "Jaunjelgava Municipality",
      "039": "Jaunpiebalga Municipality",
      "040": "Jaunpils Municipality",
      "041": "Jelgava Municipality",
      "042": "Jēkabpils Municipality",
      "043": "Kandava Municipality",
      "044": "Kārsava Municipality",
      "045": "Kocēni Municipality",
      "046": "Koknese Municipality",
      "047": "Krāslava Municipality",
      "048": "Krimulda Municipality",
      "049": "Krustpils Municipality",
      "050": "Kuldīga Municipality",
      "051": "Ķegums Municipality",
      "052": "Ķekava Municipality",
      "053": "Lielvārde Municipality",
      "054": "Limbaži Municipality",
      "055": "Līgatne Municipality",
      "056": "Līvāni Municipality",
      "057": "Lubāna Municipality",
      "058": "Ludza Municipality",
      "059": "Madona Municipality",
      "060": "Mazsalaca Municipality",
      "061": "Mālpils Municipality",
      "062": "Mārupe Municipality",
      "063": "Mērsrags Municipality",
      "064": "Naukšēni Municipality",
      "065": "Nereta Municipality",
      "066": "Nīca Municipality",
      "067": "Ogre Municipality",
      "068": "Olaine Municipality",
      "069": "Ozolnieki Municipality",
      "070": "Pārgauja Municipality",
      "071": "Pāvilosta Municipality",
      "072": "Pļaviņas Municipality",
      "073": "Preiļi Municipality",
      "074": "Priekule Municipality",
      "075": "Priekuļi Municipality",
      "076": "Rauna Municipality",
      "077": "Rēzekne Municipality",
      "078": "Riebiņi Municipality",
      "079": "Roja Municipality",
      "080": "Ropaži Municipality",
      "081": "Rucava Municipality",
      "082": "Rugāji Municipality",
      "083": "Rundāle Municipality",
      "084": "Rūjiena Municipality",
      "085": "Sala Municipality",
      "086": "Salacgrīva Municipality",
      "087": "Salaspils Municipality",
      "088": "Saldus Municipality",
      "089": "Saulkrasti Municipality",
      "090": "Sēja Municipality",
      "091": "Sigulda Municipality",
      "092": "Skrīveri Municipality",
      "093": "Skrunda Municipality",
      "094": "Smiltene Municipality",
      "095": "Stopiņi Municipality",
      "096": "Strenči Municipality",
      "097": "Talsi Municipality",
      "098": "Tērvete Municipality",
      "099": "Tukums Municipality",
      DGV: "Daugavpils",
      JEL: "Jelgava",
      JKB: "Jēkabpils",
      JUR: "Jūrmala",
      LPX: "Liepāja",
      REZ: "Rēzekne",
      RIX: "Riga",
      VEN: "Ventspils",
      VMR: "Valmiera",
    },
    LY: {
      BA: "Benghazi",
      DR: "Derna District",
      GT: "Ghat District",
      JA: "Jabal al Akhdar",
      JG: "Jabal al Gharbi District",
      JI: "Jafara",
      JU: "Jufra",
      KF: "Kufra District",
      MB: "Murqub",
      MI: "Misrata District",
      MJ: "Marj District",
      MQ: "Murzuq District",
      NL: "Nalut District",
      NQ: "Nuqat al Khams",
      SB: "Sabha District",
      SR: "Sirte District",
      TB: "Tripoli District",
      WA: "Al Wahat District",
      WD: "Wadi al Hayaa District",
      WS: "Wadi al Shatii District",
      ZA: "Zawiya District",
    },
    MA: {
      "10": "Guelmim-Oued Noun (EH-partial)",
      "11": "Laâyoune-Sakia El Hamra (EH-partial)",
      "12": "Dakhla-Oued Ed-Dahab (EH)",
      "01": "Tanger-Tétouan-Al Hoceïma",
      "02": "L'Oriental",
      "03": "Fès-Meknès",
      "04": "Rabat-Salé-Kénitra",
      "05": "Béni Mellal-Khénifra",
      "06": "Casablanca-Settat",
      "07": "Marrakesh-Safi",
      "08": "Drâa-Tafilalet",
      "09": "Souss-Massa",
      AGD: "Agadir-Ida-Ou-Tanane",
      AOU: "Aousserd (EH)",
      ASZ: "Assa-Zag (EH-partial)",
      AZI: "Azilal",
      BEM: "Béni Mellal",
      BER: "Berkane",
      BES: "Benslimane",
      BOD: "Boujdour (EH)",
      BOM: "Boulemane",
      BRR: "Berrechid",
      CAS: "Casablanca",
      CHE: "Chefchaouen",
      CHI: "Chichaoua",
      CHT: "Chtouka-Ait Baha",
      DRI: "Driouch",
      ERR: "Errachidia",
      ESI: "Essaouira",
      ESM: "Es-Semara (EH-partial)",
      FAH: "Fahs-Anjra",
      FES: "Fès",
      FIG: "Figuig",
      FQH: "Fquih Ben Salah",
      GUE: "Guelmim",
      GUF: "Guercif",
      HAJ: "El Hajeb",
      HAO: "Al Haouz",
      HOC: "Al Hoceïma",
      IFR: "Ifrane",
      INE: "Inezgane-Ait Melloul",
      JDI: "El Jadida",
      JRA: "Jerada",
      KEN: "Kénitra",
      KES: "El Kelâa des Sraghna",
      KHE: "Khémisset",
      KHN: "Khénifra",
      KHO: "Khouribga",
      LAA: "Laâyoune (EH)",
      LAR: "Larache",
      MAR: "Marrakech",
      MDF: "M’diq-Fnideq",
      MED: "Médiouna",
      MEK: "Meknès",
      MID: "Midelt",
      MOH: "Mohammadia",
      MOU: "Moulay Yacoub",
      NAD: "Nador",
      NOU: "Nouaceur",
      OUA: "Ouarzazate",
      OUD: "Oued Ed-Dahab (EH)",
      OUJ: "Oujda-Angad",
      OUZ: "Ouezzane",
      RAB: "Rabat",
      REH: "Rehamna",
      SAF: "Safi",
      SAL: "Salé",
      SEF: "Sefrou",
      SET: "Settat",
      SIB: "Sidi Bennour",
      SIF: "Sidi Ifni",
      SIK: "Sidi Kacem",
      SIL: "Sidi Slimane",
      SKH: "Skhirate-Témara",
      TAF: "Tarfaya (EH-partial)",
      TAI: "Taourirt",
      TAO: "Taounate",
      TAR: "Taroudannt",
      TAT: "Tata",
      TAZ: "Taza",
      TET: "Tétouan",
      TIN: "Tinghir",
      TIZ: "Tiznit",
      TNG: "Tanger-Assilah",
      TNT: "Tan-Tan (EH-partial)",
      YUS: "Youssoufia",
      ZAG: "Zagora",
    },
    MC: {
      CL: "La Colle",
      CO: "La Condamine",
      MG: "Moneghetti",
    },
    MD: {
      AN: "Anenii Noi District",
      BA: "Bălți Municipality",
      BD: "Bender Municipality",
      BR: "Briceni District",
      BS: "Basarabeasca District",
      CA: "Cahul District",
      CL: "Călărași District",
      CM: "Cimișlia District",
      CR: "Criuleni District",
      CS: "Căușeni District",
      CT: "Cantemir District",
      CU: "Chișinău Municipality",
      DO: "Dondușeni District",
      DR: "Drochia District",
      DU: "Dubăsari District",
      ED: "Edineț District",
      FA: "Fălești District",
      FL: "Florești District",
      GA: "Gagauzia",
      GL: "Glodeni District",
      HI: "Hîncești District",
      IA: "Ialoveni District",
      NI: "Nisporeni District",
      OC: "Ocnița District",
      OR: "Orhei District",
      RE: "Rezina District",
      RI: "Rîșcani District",
      SD: "Șoldănești District",
      SI: "Sîngerei District",
      SN: "Transnistria autonomous territorial unit",
      SO: "Soroca District",
      ST: "Strășeni District",
      SV: "Ștefan Vodă District",
      TA: "Taraclia District",
      TE: "Telenești District",
      UN: "Ungheni District",
    },
    ME: {
      "10": "Kotor Municipality",
      "11": "Mojkovac Municipality",
      "12": "Nikšić Municipality",
      "13": "Plav Municipality",
      "14": "Pljevlja Municipality",
      "15": "Plužine Municipality",
      "16": "Podgorica Municipality",
      "17": "Rožaje Municipality",
      "18": "Šavnik Municipality",
      "19": "Tivat Municipality",
      "20": "Ulcinj Municipality",
      "21": "Žabljak Municipality",
      "22": "Gusinje Municipality",
      "23": "Petnjica Municipality",
      "01": "Andrijevica Municipality",
      "02": "Bar Municipality",
      "03": "Berane Municipality",
      "04": "Bijelo Polje Municipality",
      "05": "Budva Municipality",
      "06": "Old Royal Capital Cetinje",
      "07": "Danilovgrad Municipality",
      "09": "Kolašin Municipality",
    },
    MG: {
      A: "Toamasina Province",
      D: "Antsiranana Province",
      F: "Fianarantsoa Province",
      M: "Mahajanga Province",
      T: "Antananarivo Province",
      U: "Toliara Province",
    },
    MH: {
      L: "Ralik Chain",
      T: "Ratak Chain",
    },
    MK: {
      "10": "Valandovo Municipality",
      "11": "Vasilevo Municipality",
      "12": "Vevčani Municipality",
      "13": "Veles Municipality",
      "14": "Vinica Municipality",
      "15": "Vraneštica Municipality",
      "16": "Vrapčište Municipality",
      "17": "Gazi Baba Municipality",
      "18": "Gevgelija Municipality",
      "19": "Gostivar Municipality",
      "20": "Gradsko Municipality",
      "22": "Debarca Municipality",
      "23": "Delčevo Municipality",
      "24": "Demir Kapija Municipality",
      "25": "Demir Hisar Municipality",
      "26": "Dojran Municipality",
      "27": "Dolneni Municipality",
      "28": "Drugovo Municipality",
      "29": "Gjorče Petrov Municipality",
      "30": "Želino Municipality",
      "31": "Zajas Municipality",
      "32": "Zelenikovo Municipality",
      "33": "Zrnovci Municipality",
      "34": "Ilinden Municipality",
      "35": "Jegunovce Municipality",
      "36": "Kavadarci Municipality",
      "37": "Karbinci",
      "38": "Karpoš Municipality",
      "39": "Kisela Voda Municipality",
      "40": "Kičevo Municipality",
      "41": "Konče Municipality",
      "42": "Kočani Municipality",
      "43": "Kratovo Municipality",
      "44": "Kriva Palanka Municipality",
      "45": "Krivogaštani Municipality",
      "46": "Kruševo Municipality",
      "47": "Kumanovo Municipality",
      "48": "Lipkovo Municipality",
      "49": "Lozovo Municipality",
      "50": "Mavrovo and Rostuša Municipality",
      "51": "Makedonska Kamenica Municipality",
      "52": "Makedonski Brod Municipality",
      "53": "Mogila Municipality",
      "54": "Negotino Municipality",
      "55": "Novaci Municipality",
      "56": "Novo Selo Municipality",
      "57": "Oslomej Municipality",
      "58": "Ohrid Municipality",
      "59": "Petrovec Municipality",
      "60": "Pehčevo Municipality",
      "61": "Plasnica Municipality",
      "62": "Prilep Municipality",
      "63": "Probištip Municipality",
      "64": "Radoviš Municipality",
      "65": "Rankovce Municipality",
      "66": "Resen Municipality",
      "67": "Rosoman Municipality",
      "68": "Saraj Municipality",
      "69": "Sveti Nikole Municipality",
      "70": "Sopište Municipality",
      "71": "Staro Nagoričane Municipality",
      "72": "Struga Municipality",
      "73": "Strumica Municipality",
      "74": "Studeničani Municipality",
      "75": "Tearce Municipality",
      "76": "Tetovo Municipality",
      "77": "Centar Municipality",
      "78": "Centar Župa Municipality",
      "79": "Čair Municipality",
      "80": "Čaška Municipality",
      "81": "Češinovo-Obleševo Municipality",
      "82": "Čučer-Sandevo Municipality",
      "83": "Štip Municipality",
      "84": "Šuto Orizari Municipality",
      "85": "Greater Skopje",
      "01": "Aerodrom Municipality",
      "02": "Aračinovo Municipality",
      "03": "Berovo Municipality",
      "04": "Bitola Municipality",
      "05": "Bogdanci Municipality",
      "06": "Bogovinje Municipality",
      "07": "Bosilovo Municipality",
      "08": "Brvenica Municipality",
      "09": "Butel Municipality",
    },
    ML: {
      "1": "Kayes Region",
      "2": "Koulikoro Region",
      "3": "Sikasso Region",
      "4": "Ségou Region",
      "5": "Mopti Region",
      "6": "Tombouctou Region",
      "7": "Gao Region",
      "8": "Kidal Region",
      "9": "Ménaka Region",
      "10": "Taoudénit Region",
      BKO: "Bamako",
    },
    MM: {
      "11": "Kachin State",
      "12": "Kayah State",
      "13": "Kayin State",
      "14": "Chin State",
      "15": "Mon State",
      "16": "Rakhine State",
      "17": "Shan State",
      "18": "Naypyidaw Union Territory",
      "01": "Sagaing Region",
      "02": "Bago",
      "03": "Magway Region",
      "04": "Mandalay Region",
      "05": "Tanintharyi Region",
      "06": "Yangon Region",
      "07": "Ayeyarwady Region",
    },
    MN: {
      "035": "Orkhon Province",
      "037": "Darkhan-Uul Province",
      "039": "Khentii Province",
      "041": "Khövsgöl Province",
      "043": "Khovd Province",
      "046": "Uvs Province",
      "047": "Töv Province",
      "049": "Selenge Province",
      "051": "Sükhbaatar Province",
      "053": "Ömnögovi Province",
      "055": "Övörkhangai Province",
      "057": "Zavkhan Province",
      "059": "Dundgovi Province",
      "061": "Dornod Province",
      "063": "Dornogovi Province",
      "064": "Govisümber Province",
      "065": "Govi-Altai Province",
      "067": "Bulgan Province",
      "069": "Bayankhongor Province",
      "071": "Bayan-Ölgii Province",
      "073": "Arkhangai Province",
    },
    MR: {
      "10": "Guidimaka Region",
      "11": "Tiris Zemmour Region",
      "12": "Inchiri Region",
      "13": "Nouakchott-Ouest Region",
      "14": "Nouakchott-Nord Region",
      "15": "Nouakchott-Sud Region",
      "01": "Hodh Ech Chargui Region",
      "02": "Hodh El Gharbi Region",
      "03": "Assaba Region",
      "04": "Gorgol Region",
      "05": "Brakna Region",
      "06": "Trarza Region",
      "07": "Adrar Region",
      "08": "Dakhlet Nouadhibou",
      "09": "Tagant Region",
    },
    MT: {
      "10": "Fontana",
      "11": "Gudja",
      "12": "Gżira",
      "13": "Għajnsielem",
      "14": "Għarb",
      "15": "Għargħur",
      "16": "Għasri",
      "17": "Għaxaq",
      "18": "Ħamrun",
      "19": "Iklin",
      "20": "Senglea",
      "21": "Kalkara",
      "22": "Kerċem",
      "23": "Kirkop",
      "24": "Lija",
      "25": "Luqa",
      "26": "Marsa",
      "27": "Marsaskala",
      "28": "Marsaxlokk",
      "29": "Mdina",
      "30": "Mellieħa",
      "31": "Mġarr",
      "32": "Mosta",
      "33": "Mqabba",
      "34": "Msida",
      "35": "Mtarfa",
      "36": "Munxar",
      "37": "Nadur",
      "38": "Naxxar",
      "39": "Paola",
      "40": "Pembroke",
      "41": "Pietà",
      "42": "Qala",
      "43": "Qormi",
      "44": "Qrendi",
      "45": "Victoria",
      "46": "Rabat",
      "48": "St. Julian's",
      "49": "San Ġwann",
      "50": "Saint Lawrence",
      "51": "St. Paul's Bay",
      "52": "Sannat",
      "53": "Santa Luċija",
      "54": "Santa Venera",
      "55": "Siġġiewi",
      "56": "Sliema",
      "57": "Swieqi",
      "58": "Ta' Xbiex",
      "59": "Tarxien",
      "60": "Valletta",
      "61": "Xagħra",
      "62": "Xewkija",
      "63": "Xgħajra",
      "64": "Żabbar",
      "65": "Żebbuġ Gozo",
      "66": "Żebbuġ Malta",
      "67": "Żejtun",
      "68": "Żurrieq",
      "01": "Attard",
      "02": "Balzan",
      "03": "Birgu",
      "04": "Birkirkara",
      "05": "Birżebbuġa",
      "06": "Cospicua",
      "07": "Dingli",
      "08": "Fgura",
      "09": "Floriana",
    },
    MU: {
      AG: "Agaléga",
      BL: "Rivière Noire District",
      BR: "Beau Bassin-Rose Hill",
      CC: "Cargados Carajos",
      CU: "Curepipe",
      FL: "Flacq District",
      GP: "Grand Port District",
      MO: "Moka District",
      PA: "Pamplemousses District",
      PL: "Port Louis District",
      PU: "Port Louis",
      PW: "Plaines Wilhems District",
      QB: "Quatre Bornes",
      RO: "Rodrigues",
      RR: "Rivière du Rempart District",
      SA: "Savanne District",
      VP: "Vacoas-Phoenix",
    },
    MV: {
      "12": "Meemu Atoll",
      "13": "Raa Atoll",
      "14": "Faafu Atoll",
      "17": "Dhaalu Atoll",
      "23": "Haa Dhaalu Atoll",
      "24": "Shaviyani Atoll",
      "25": "Noonu Atoll",
      "26": "Kaafu Atoll",
      "27": "Gaafu Alif Atoll",
      "28": "Gaafu Dhaalu Atoll",
      "29": "Gnaviyani Atoll",
      "00": "Alif Dhaal Atoll",
      "01": "Addu Atoll",
      "02": "Alif Alif Atoll",
      "03": "Lhaviyani Atoll",
      "04": "Vaavu Atoll",
      "05": "Laamu Atoll",
      "07": "Haa Alif Atoll",
      "08": "Thaa Atoll",
      CE: "Central Province",
      MLE: "Malé",
      NC: "North Central Province",
      NO: "North Province",
      SC: "South Central Province",
      SU: "South Province",
      US: "Upper South Province",
    },
    MW: {
      BA: "Balaka District",
      BL: "Blantyre District",
      C: "Central Region",
      CK: "Chikwawa District",
      CR: "Chiradzulu District",
      CT: "Chitipa district",
      DE: "Dedza District",
      DO: "Dowa District",
      KR: "Karonga District",
      KS: "Kasungu District",
      LI: "Lilongwe District",
      LK: "Likoma District",
      MC: "Mchinji District",
      MG: "Mangochi District",
      MH: "Machinga District",
      MU: "Mulanje District",
      MW: "Mwanza District",
      MZ: "Mzimba District",
      N: "Northern Region",
      NB: "Nkhata Bay District",
      NI: "Ntchisi District",
      NK: "Nkhotakota District",
      NS: "Nsanje District",
      NU: "Ntcheu District",
      PH: "Phalombe District",
      RU: "Rumphi District",
      S: "Southern Region",
      SA: "Salima District",
      TH: "Thyolo District",
      ZO: "Zomba District",
    },
    MX: {
      AGU: "Aguascalientes",
      BCN: "Baja California",
      BCS: "Baja California Sur",
      CAM: "Campeche",
      CDMX: "Ciudad de México",
      CHH: "Chihuahua",
      CHP: "Chiapas",
      COA: "Coahuila de Zaragoza",
      COL: "Colima",
      DUR: "Durango",
      GRO: "Guerrero",
      GUA: "Guanajuato",
      HID: "Hidalgo",
      JAL: "Jalisco",
      MEX: "Estado de México",
      MIC: "Michoacán de Ocampo",
      MOR: "Morelos",
      NAY: "Nayarit",
      NLE: "Nuevo León",
      OAX: "Oaxaca",
      PUE: "Puebla",
      QUE: "Querétaro",
      ROO: "Quintana Roo",
      SIN: "Sinaloa",
      SLP: "San Luis Potosí",
      SON: "Sonora",
      TAB: "Tabasco",
      TAM: "Tamaulipas",
      TLA: "Tlaxcala",
      VER: "Veracruz de Ignacio de la Llave",
      YUC: "Yucatán",
      ZAC: "Zacatecas",
    },
    MY: {
      "10": "Selangor",
      "11": "Terengganu",
      "12": "Sabah",
      "13": "Sarawak",
      "14": "Kuala Lumpur",
      "15": "Labuan",
      "16": "Putrajaya",
      "01": "Johor",
      "02": "Kedah",
      "03": "Kelantan",
      "04": "Malacca",
      "05": "Negeri Sembilan",
      "06": "Pahang",
      "07": "Penang",
      "08": "Perak",
      "09": "Perlis",
    },
    MZ: {
      A: "Niassa Province",
      B: "Manica Province",
      G: "Gaza Province",
      I: "Inhambane Province",
      L: "Maputo Province",
      MPM: "Maputo",
      N: "Nampula Province",
      P: "Cabo Delgado Province",
      Q: "Zambezia Province",
      S: "Sofala Province",
      T: "Tete Province",
    },
    NA: {
      CA: "Zambezi Region",
      ER: "Erongo Region",
      HA: "Hardap Region",
      KA: "Karas Region",
      KE: "Kavango East Region",
      KH: "Khomas Region",
      KU: "Kunene Region",
      KW: "Kavango West Region",
      OD: "Otjozondjupa Region",
      OH: "Omaheke Region",
      ON: "Oshana Region",
      OS: "Omusati Region",
      OT: "Oshikoto Region",
      OW: "Ohangwena Region",
    },
    NE: {
      "1": "Agadez Region",
      "2": "Diffa Region",
      "3": "Dosso Region",
      "4": "Maradi Region",
      "5": "Tahoua Region",
      "6": "Tillabéri Region",
      "7": "Zinder Region",
    },
    NG: {
      AB: "Abia",
      AD: "Adamawa",
      AK: "Akwa Ibom",
      AN: "Anambra",
      BA: "Bauchi",
      BE: "Benue",
      BO: "Borno",
      BY: "Bayelsa",
      CR: "Cross River",
      DE: "Delta",
      EB: "Ebonyi",
      ED: "Edo",
      EK: "Ekiti",
      EN: "Enugu",
      FC: "Abuja Federal Capital Territory",
      GO: "Gombe",
      IM: "Imo",
      JI: "Jigawa",
      KD: "Kaduna",
      KE: "Kebbi",
      KN: "Kano",
      KO: "Kogi",
      KT: "Katsina",
      KW: "Kwara",
      LA: "Lagos",
      NA: "Nasarawa",
      NI: "Niger",
      OG: "Ogun",
      ON: "Ondo",
      OS: "Osun",
      OY: "Oyo",
      PL: "Plateau",
      RI: "Rivers",
      SO: "Sokoto",
      TA: "Taraba",
      YO: "Yobe",
      ZA: "Zamfara",
    },
    NI: {
      AN: "North Caribbean Coast",
      AS: "South Caribbean Coast",
      BO: "Boaco",
      CA: "Carazo",
      CI: "Chinandega",
      CO: "Chontales",
      ES: "Estelí",
      GR: "Granada",
      JI: "Jinotega",
      LE: "León",
      MD: "Madriz",
      MN: "Managua",
      MS: "Masaya",
      MT: "Matagalpa",
      NS: "Nueva Segovia",
      RI: "Rivas",
      SJ: "Río San Juan",
    },
    NL: {
      BQ1: "Bonaire",
      BQ2: "Saba",
      BQ3: "Sint Eustatius",
      DR: "Drenthe",
      FL: "Flevoland",
      FR: "Friesland",
      GE: "Gelderland",
      GR: "Groningen",
      LI: "Limburg",
      NB: "North Brabant",
      NH: "North Holland",
      OV: "Overijssel",
      UT: "Utrecht",
      ZE: "Zeeland",
      ZH: "South Holland",
    },
    NO: {
      "10": "Vest-Agder",
      "11": "Rogaland",
      "12": "Hordaland",
      "14": "Sogn og Fjordane",
      "15": "Møre og Romsdal",
      "16": "Sør-Trøndelag",
      "17": "Nord-Trøndelag",
      "18": "Nordland",
      "19": "Troms",
      "20": "Finnmark",
      "21": "Svalbard",
      "22": "Jan Mayen",
      "50": "Trøndelag",
      "01": "Østfold",
      "02": "Akershus",
      "03": "Oslo",
      "04": "Hedmark",
      "05": "Oppland",
      "06": "Buskerud",
      "07": "Vestfold",
      "08": "Telemark",
    },
    NP: {
      "1": "Central Region",
      "2": "Mid-Western Region",
      "3": "Western Region",
      "4": "Eastern Development Region",
      "5": "Far-Western Development Region",
      BA: "Bagmati Zone",
      BH: "Bheri Zone",
      DH: "Dhaulagiri Zone",
      GA: "Gandaki Zone",
      JA: "Janakpur Zone",
      KA: "Karnali Zone",
      KO: "Kosi Zone",
      LU: "Lumbini Zone",
      MA: "Mahakali Zone",
      ME: "Mechi Zone",
      NA: "Narayani Zone",
      RA: "Rapti Zone",
      SA: "Sagarmatha Zone",
      SE: "Seti Zone",
    },
    NR: {
      "10": "Ijuw District",
      "11": "Meneng District",
      "12": "Nibok District",
      "13": "Uaboe District",
      "14": "Yaren District",
      "01": "Aiwo District",
      "02": "Anabar District",
      "03": "Anetan District",
      "04": "Anibare District",
      "05": "Baiti District",
      "06": "Boe District",
      "07": "Buada District",
      "08": "Denigomodu District",
      "09": "Ewa District",
    },
    NZ: {
      AUK: "Auckland Region",
      BOP: "Bay of Plenty Region",
      CAN: "Canterbury Region",
      CIT: "Chatham Islands",
      GIS: "Gisborne District",
      HKB: "Hawke's Bay Region",
      MBH: "Marlborough Region",
      MWT: "Manawatu-Wanganui Region",
      NSN: "Nelson Region",
      NTL: "Northland Region",
      OTA: "Otago Region",
      STL: "Southland Region",
      TAS: "Tasman District",
      TKI: "Taranaki Region",
      WGN: "Wellington Region",
      WKO: "Waikato Region",
      WTC: "West Coast Region",
    },
    OM: {
      BA: "Al Batinah Region",
      BJ: "Al Batinah South Governorate",
      BS: "Al Batinah North Governorate",
      BU: "Al Buraimi Governorate",
      DA: "Ad Dakhiliyah Governorate",
      MA: "Muscat Governorate",
      MU: "Musandam Governorate",
      SH: "Ash Sharqiyah Region",
      SJ: "Ash Sharqiyah South Governorate",
      SS: "Ash Sharqiyah North Governorate",
      WU: "Al Wusta Governorate",
      ZA: "Ad Dhahirah Governorate",
      ZU: "Dhofar Governorate",
    },
    PA: {
      "1": "Bocas del Toro Province",
      "2": "Coclé Province",
      "3": "Colón Province",
      "4": "Chiriquí Province",
      "5": "Darién Province",
      "6": "Herrera Province",
      "7": "Los Santos Province",
      "8": "Panamá Province",
      "9": "Veraguas Province",
      "10": "Panamá Oeste Province",
      EM: "Emberá-Wounaan Comarca",
      KY: "Guna Yala",
      NB: "Ngöbe-Buglé Comarca",
    },
    PE: {
      AMA: "Amazonas",
      ANC: "Áncash",
      APU: "Apurímac",
      ARE: "Arequipa",
      AYA: "Ayacucho",
      CAJ: "Cajamarca",
      CAL: "Callao",
      CUS: "Cusco",
      HUC: "Huanuco",
      HUV: "Huancavelica",
      ICA: "Ica",
      JUN: "Junín",
      LAL: "La Libertad",
      LAM: "Lambayeque",
      LIM: "Lima",
      LOR: "Loreto",
      MDD: "Madre de Dios",
      MOQ: "Moquegua",
      PAS: "Pasco",
      PIU: "Piura",
      PUN: "Puno",
      SAM: "San Martín",
      TAC: "Tacna",
      TUM: "Tumbes",
      UCA: "Ucayali",
    },
    PG: {
      CPK: "Chimbu Province",
      CPM: "Central Province",
      EBR: "East New Britain",
      EHG: "Eastern Highlands Province",
      EPW: "Enga Province",
      GPK: "Gulf",
      HLA: "Hela",
      JWK: "Jiwaka Province",
      MBA: "Milne Bay Province",
      MPL: "Morobe Province",
      MPM: "Madang Province",
      MRL: "Manus Province",
      NCD: "Port Moresby",
      NIK: "New Ireland Province",
      NPP: "Oro Province",
      NSB: "Bougainville",
      SAN: "Sandaun Province",
      SHM: "Southern Highlands Province",
      WBK: "West New Britain Province",
      WHM: "Western Highlands Province",
      WPD: "Western Province",
    },
    PH: {
      "10": "Northern Mindanao",
      "11": "Davao Region",
      "12": "Soccsksargen",
      "13": "Caraga",
      "14": "Autonomous Region in Muslim Mindanao",
      "15": "Cordillera Administrative Region",
      "40": "Calabarzon",
      "41": "Mimaropa",
      "01": "Ilocos Region",
      "02": "Cagayan Valley",
      "03": "Central Luzon",
      "05": "Bicol Region",
      "06": "Western Visayas",
      "07": "Central Visayas",
      "08": "Eastern Visayas",
      "09": "Zamboanga Peninsula",
      ABR: "Abra",
      AGN: "Agusan del Norte",
      AGS: "Agusan del Sur",
      AKL: "Aklan",
      ALB: "Albay",
      ANT: "Antique",
      APA: "Apayao",
      AUR: "Aurora",
      BAN: "Bataan",
      BAS: "Basilan",
      BEN: "Benguet",
      BIL: "Biliran",
      BOH: "Bohol",
      BTG: "Batangas",
      BTN: "Batanes",
      BUK: "Bukidnon",
      BUL: "Bulacan",
      CAG: "Cagayan",
      CAM: "Camiguin",
      CAN: "Camarines Norte",
      CAP: "Capiz",
      CAS: "Camarines Sur",
      CAT: "Catanduanes",
      CAV: "Cavite",
      CEB: "Cebu",
      COM: "Compostela Valley",
      DAO: "Davao Oriental",
      DAS: "Davao del Sur",
      DAV: "Davao del Norte",
      DIN: "Dinagat Islands",
      DVO: "Davao Occidental",
      EAS: "Eastern Samar",
      GUI: "Guimaras",
      IFU: "Ifugao",
      ILI: "Iloilo",
      ILN: "Ilocos Norte",
      ILS: "Ilocos Sur",
      ISA: "Isabela",
      KAL: "Kalinga",
      LAG: "Laguna",
      LAN: "Lanao del Norte",
      LAS: "Lanao del Sur",
      LEY: "Leyte",
      LUN: "La Union",
      MAD: "Marinduque",
      MAG: "Maguindanao",
      MAS: "Masbate",
      MDC: "Occidental Mindoro",
      MDR: "Oriental Mindoro",
      MOU: "Mountain Province",
      MSC: "Misamis Occidental",
      MSR: "Misamis Oriental",
      NCO: "Cotabato",
      NCR: "Metro Manila",
      NEC: "Negros Occidental",
      NER: "Negros Oriental",
      NSA: "Northern Samar",
      NUE: "Nueva Ecija",
      NUV: "Nueva Vizcaya",
      PAM: "Pampanga",
      PAN: "Pangasinan",
      PLW: "Palawan",
      QUE: "Quezon",
      QUI: "Quirino",
      RIZ: "Rizal",
      ROM: "Romblon",
      SAR: "Sarangani",
      SCO: "South Cotabato",
      SIG: "Siquijor",
      SLE: "Southern Leyte",
      SLU: "Sulu",
      SOR: "Sorsogon",
      SUK: "Sultan Kudarat",
      SUN: "Surigao del Norte",
      SUR: "Surigao del Sur",
      TAR: "Tarlac",
      TAW: "Tawi-Tawi",
      ZAN: "Zamboanga del Norte",
      ZAS: "Zamboanga del Sur",
      ZMB: "Zambales",
      ZSI: "Zamboanga Sibugay",
    },
    PK: {
      BA: "Balochistan",
      GB: "Gilgit-Baltistan",
      IS: "Islamabad Capital Territory",
      JK: "Azad Kashmir",
      KP: "Khyber Pakhtunkhwa",
      PB: "Punjab",
      SD: "Sindh",
      TA: "Federally Administered Tribal Areas",
    },
    PL: {
      DS: "Lower Silesian Voivodeship",
      KP: "Kuyavian-Pomeranian Voivodeship",
      LB: "Lubusz Voivodeship",
      LD: "Łódź Voivodeship",
      LU: "Lublin Voivodeship",
      MA: "Lesser Poland Voivodeship",
      MZ: "Masovian Voivodeship",
      OP: "Opole Voivodeship",
      PD: "Podlaskie Voivodeship",
      PK: "Podkarpackie Voivodeship",
      PM: "Pomeranian Voivodeship",
      SK: "Świętokrzyskie Voivodeship",
      SL: "Silesian Voivodeship",
      WN: "Warmian-Masurian Voivodeship",
      WP: "Greater Poland Voivodeship",
      ZP: "West Pomeranian Voivodeship",
    },
    PT: {
      "10": "Leiria",
      "11": "Lisbon",
      "12": "Portalegre",
      "13": "Porto",
      "14": "Santarém",
      "15": "Setúbal",
      "16": "Viana do Castelo",
      "17": "Vila Real",
      "18": "Viseu",
      "20": "Açores",
      "30": "Madeira",
      "01": "Aveiro",
      "02": "Beja",
      "03": "Braga",
      "04": "Bragança",
      "05": "Castelo Branco",
      "06": "Coimbra",
      "07": "Évora",
      "08": "Faro",
      "09": "Guarda",
    },
    PW: {
      "100": "Kayangel",
      "150": "Koror",
      "212": "Melekeok",
      "214": "Ngaraard",
      "218": "Ngarchelong",
      "222": "Ngardmau",
      "224": "Ngatpang",
      "226": "Ngchesar",
      "227": "Ngeremlengui",
      "228": "Ngiwal",
      "350": "Peleliu",
      "370": "Sonsorol",
      "002": "Aimeliik",
      "004": "Airai",
      "010": "Angaur",
      "050": "Hatohobei",
    },
    PY: {
      "1": "Concepción Department",
      "2": "San Pedro Department",
      "3": "Cordillera Department",
      "4": "Guairá Department",
      "5": "Caaguazú",
      "6": "Caazapá",
      "7": "Itapúa",
      "8": "Misiones Department",
      "9": "Paraguarí Department",
      "10": "Alto Paraná Department",
      "11": "Central Department",
      "12": "Ñeembucú Department",
      "13": "Amambay Department",
      "14": "Canindeyú",
      "15": "Presidente Hayes Department",
      "16": "Alto Paraguay Department",
      "19": "Boquerón Department",
    },
    QA: {
      DA: "Doha",
      KH: "Al Khor",
      MS: "Madinat ash Shamal",
      RA: "Al Rayyan Municipality",
      SH: "Al-Shahaniya",
      US: "Umm Salal Municipality",
      WA: "Al Wakrah",
      ZA: "Al Daayen",
    },
    RO: {
      AB: "Alba",
      AG: "Arges",
      AR: "Arad County",
      B: "Bucharest",
      BC: "Bacău County",
      BH: "Bihor County",
      BN: "Bistrița-Năsăud County",
      BR: "Braila",
      BT: "Botoșani County",
      BV: "Brașov County",
      BZ: "Buzău County",
      CJ: "Cluj County",
      CL: "Călărași County",
      CS: "Caraș-Severin County",
      CT: "Constanța County",
      CV: "Covasna County",
      DB: "Dâmbovița County",
      DJ: "Dolj County",
      GJ: "Gorj County",
      GL: "Galați County",
      GR: "Giurgiu County",
      HD: "Hunedoara County",
      HR: "Harghita County",
      IF: "Ilfov County",
      IL: "Ialomița County",
      IS: "Iași County",
      MH: "Mehedinți County",
      MM: "Maramureș County",
      MS: "Mureș County",
      NT: "Neamț County",
      OT: "Olt County",
      PH: "Prahova County",
      SB: "Sibiu County",
      SJ: "Sălaj County",
      SM: "Satu Mare County",
      SV: "Suceava County",
      TL: "Tulcea County",
      TM: "Timiș County",
      TR: "Teleorman County",
      VL: "Vâlcea County",
      VN: "Vrancea County",
      VS: "Vaslui County",
    },
    RS: {
      "10": "Podunavlje District",
      "11": "Braničevo District",
      "12": "Šumadija District",
      "13": "Pomoravlje District",
      "14": "Bor District",
      "15": "Zaječar District",
      "16": "Zlatibor District",
      "17": "Moravica District",
      "18": "Raška District",
      "19": "Rasina District",
      "20": "Nišava District",
      "21": "Toplica District",
      "22": "Pirot District",
      "23": "Jablanica District",
      "24": "Pčinja District",
      "00": "Belgrade",
      "01": "North Bačka District",
      "02": "Central Banat District",
      "03": "North Banat District",
      "04": "South Banat District",
      "05": "West Bačka District",
      "06": "South Bačka District",
      "07": "Srem District",
      "08": "Mačva District",
      "09": "Kolubara District",
      VO: "Vojvodina",
    },
    RU: {
      AD: "Republic of Adygea",
      AL: "Altai Republic",
      ALT: "Altai Krai",
      AMU: "Amur Oblast",
      ARK: "Arkhangelsk",
      AST: "Astrakhan Oblast",
      BA: "Republic of Bashkortostan",
      BEL: "Belgorod Oblast",
      BRY: "Bryansk Oblast",
      BU: "Republic of Buryatia",
      CE: "Chechen Republic",
      CHE: "Chelyabinsk Oblast",
      CHU: "Chukotka Autonomous Okrug",
      CU: "Chuvash Republic",
      DA: "Republic of Dagestan",
      IN: "Republic of Ingushetia",
      IRK: "Irkutsk",
      IVA: "Ivanovo Oblast",
      KAM: "Kamchatka Krai",
      KB: "Kabardino-Balkar Republic",
      KC: "Karachay-Cherkess Republic",
      KDA: "Krasnodar Krai",
      KEM: "Kemerovo Oblast",
      KGD: "Kaliningrad",
      KGN: "Kurgan Oblast",
      KHA: "Khabarovsk Krai",
      KHM: "Khanty-Mansi Autonomous Okrug",
      KIR: "Kirov Oblast",
      KK: "Republic of Khakassia",
      KL: "Republic of Kalmykia",
      KLU: "Kaluga Oblast",
      KO: "Komi Republic",
      KOS: "Kostroma Oblast",
      KR: "Republic of Karelia",
      KRS: "Kursk Oblast",
      KYA: "Krasnoyarsk Krai",
      LEN: "Leningrad Oblast",
      LIP: "Lipetsk Oblast",
      MAG: "Magadan Oblast",
      ME: "Mari El Republic",
      MO: "Republic of Mordovia",
      MOS: "Moscow Oblast",
      MOW: "Moscow",
      MUR: "Murmansk Oblast",
      NEN: "Nenets Autonomous Okrug",
      NGR: "Novgorod Oblast",
      NIZ: "Nizhny Novgorod Oblast",
      NVS: "Novosibirsk",
      OMS: "Omsk Oblast",
      ORE: "Orenburg Oblast",
      ORL: "Oryol Oblast",
      PER: "Perm Krai",
      PNZ: "Penza Oblast",
      PRI: "Primorsky Krai",
      PSK: "Pskov Oblast",
      ROS: "Rostov Oblast",
      RYA: "Ryazan Oblast",
      SA: "Sakha Republic",
      SAK: "Sakhalin",
      SAM: "Samara Oblast",
      SAR: "Saratov Oblast",
      SE: "Republic of North Ossetia-Alania",
      SMO: "Smolensk Oblast",
      SPE: "Saint Petersburg",
      STA: "Stavropol Krai",
      SVE: "Sverdlovsk",
      TA: "Republic of Tatarstan",
      TAM: "Tambov Oblast",
      TOM: "Tomsk Oblast",
      TUL: "Tula Oblast",
      TVE: "Tver Oblast",
      TY: "Tuva Republic",
      TYU: "Tyumen Oblast",
      "UA-40": "Sevastopol",
      UD: "Udmurt Republic",
      ULY: "Ulyanovsk Oblast",
      VGG: "Volgograd Oblast",
      VLA: "Vladimir Oblast",
      VLG: "Vologda Oblast",
      VOR: "Voronezh Oblast",
      YAN: "Yamalo-Nenets Autonomous Okrug",
      YAR: "Yaroslavl Oblast",
      YEV: "Jewish Autonomous Oblast",
      ZAB: "Zabaykalsky Krai",
    },
    RW: {
      "01": "Kigali district",
      "02": "Eastern Province",
      "03": "Northern Province",
      "04": "Western Province",
      "05": "Southern Province",
    },
    SA: {
      "10": "Najran",
      "11": "Al Bahah",
      "12": "Al Jawf",
      "14": "'Asir",
      "01": "Riyadh",
      "02": "Makkah",
      "03": "Al Madinah",
      "04": "Eastern Province",
      "05": "Al-Qassim",
      "06": "Ha'il",
      "07": "Tabuk",
      "08": "Northern Borders",
      "09": "Jizan",
    },
    SB: {
      CE: "Central Province",
      CH: "Choiseul Province",
      CT: "Honiara",
      GU: "Guadalcanal Province",
      IS: "Isabel Province",
      MK: "Makira-Ulawa Province",
      ML: "Malaita Province",
      RB: "Rennell and Bellona Province",
      TE: "Temotu Province",
      WE: "Western Province",
    },
    SC: {
      "10": "Bel Ombre",
      "11": "Cascade",
      "12": "Glacis",
      "13": "Grand'Anse Mahé",
      "14": "Grand'Anse Praslin",
      "15": "La Digue",
      "16": "La Rivière Anglaise",
      "17": "Mont Buxton",
      "18": "Mont Fleuri",
      "19": "Plaisance",
      "20": "Pointe La Rue",
      "21": "Port Glaud",
      "22": "Saint Louis",
      "23": "Takamaka",
      "24": "Les Mamelles",
      "25": "Roche Caiman",
      "01": "Anse-aux-Pins",
      "02": "Anse Boileau",
      "04": "Au Cap",
      "05": "Anse Royale",
      "06": "Baie Lazare",
      "07": "Baie Sainte Anne",
      "08": "Beau Vallon",
      "09": "Bel Air",
    },
    SD: {
      DC: "Central Darfur",
      DE: "East Darfur",
      DN: "North Darfur",
      DS: "South Darfur",
      DW: "West Darfur",
      GD: "Al Qadarif",
      GK: "West Kordofan",
      GZ: "Al Jazirah",
      KA: "Kassala",
      KH: "Khartoum",
      KN: "North Kordofan",
      KS: "South Kordofan",
      NB: "Blue Nile",
      NO: "Northern",
      NR: "River Nile",
      NW: "White Nile",
      RS: "Red Sea",
      SI: "Sennar",
    },
    SE: {
      AB: "Stockholm County",
      AC: "Västerbotten County",
      BD: "Norrbotten County",
      C: "Uppsala County",
      D: "Södermanland County",
      E: "Östergötland County",
      F: "Jönköping County",
      G: "Kronoberg County",
      H: "Kalmar County",
      I: "Gotland County",
      K: "Blekinge",
      M: "Skåne County",
      N: "Halland County",
      O: "Västra Götaland County",
      S: "Värmland County",
      T: "Örebro County",
      U: "Västmanland County",
      W: "Dalarna County",
      X: "Gävleborg County",
      Y: "Västernorrland County",
    },
    SG: {
      "01": "Central Singapore Community Development Council",
      "02": "North East Community Development Council",
      "03": "North West Community Development Council",
      "04": "South East Community Development Council",
      "05": "South West Community Development Council",
    },
    SI: {
      "100": "Radenci Municipality",
      "101": "Radlje ob Dravi Municipality",
      "102": "Radovljica Municipality",
      "103": "Ravne na Koroškem Municipality",
      "104": "Ribnica Municipality",
      "105": "Rogašovci Municipality",
      "106": "Rogaška Slatina Municipality",
      "107": "Rogatec Municipality",
      "108": "Ruše Municipality",
      "109": "Semič Municipality",
      "110": "Sevnica Municipality",
      "111": "Sežana Municipality",
      "112": "Slovenj Gradec City Municipality",
      "113": "Slovenska Bistrica Municipality",
      "114": "Slovenske Konjice Municipality",
      "115": "Starše Municipality",
      "116": "Sveti Jurij ob Ščavnici Municipality",
      "117": "Šenčur Municipality",
      "118": "Šentilj Municipality",
      "119": "Šentjernej Municipality",
      "120": "Šentjur Municipality",
      "121": "Škocjan Municipality",
      "122": "Škofja Loka Municipality",
      "123": "Municipality of Škofljica",
      "124": "Šmarje pri Jelšah Municipality",
      "125": "Šmartno ob Paki Municipality",
      "126": "Šoštanj Municipality",
      "127": "Štore Municipality",
      "128": "Tolmin Municipality",
      "129": "Trbovlje Municipality",
      "130": "Trebnje Municipality",
      "131": "Tržič Municipality",
      "132": "Turnišče Municipality",
      "134": "Velike Lašče Municipality",
      "135": "Videm Municipality",
      "136": "Vipava Municipality",
      "137": "Vitanje Municipality",
      "138": "Vodice Municipality",
      "139": "Vojnik Municipality",
      "140": "Vrhnika Municipality",
      "141": "Vuzenica Municipality",
      "142": "Zagorje ob Savi Municipality",
      "143": "Zavrč Municipality",
      "144": "Zreče Municipality",
      "146": "Železniki Municipality",
      "147": "Žiri Municipality",
      "148": "Benedikt Municipality",
      "149": "Bistrica ob Sotli Municipality",
      "150": "Bloke Municipality",
      "151": "Braslovče Municipality",
      "152": "Cankova Municipality",
      "153": "Cerkvenjak Municipality",
      "154": "Dobje Municipality",
      "155": "Dobrna Municipality",
      "156": "Dobrovnik Municipality",
      "157": "Dolenjske Toplice Municipality",
      "158": "Grad Municipality",
      "159": "Hajdina Municipality",
      "160": "Hoče–Slivnica Municipality",
      "161": "Hodoš Municipality",
      "162": "Horjul Municipality",
      "163": "Jezersko Municipality",
      "164": "Komenda Municipality",
      "165": "Kostel Municipality",
      "166": "Križevci Municipality",
      "167": "Lovrenc na Pohorju Municipality",
      "168": "Markovci Municipality",
      "169": "Miklavž na Dravskem Polju Municipality",
      "170": "Mirna Peč Municipality",
      "171": "Oplotnica",
      "172": "Podlehnik Municipality",
      "173": "Polzela Municipality",
      "174": "Prebold Municipality",
      "175": "Prevalje Municipality",
      "176": "Razkrižje Municipality",
      "177": "Ribnica na Pohorju Municipality",
      "178": "Selnica ob Dravi Municipality",
      "179": "Sodražica Municipality",
      "180": "Solčava Municipality",
      "181": "Sveta Ana Municipality",
      "182": "Sveti Andraž v Slovenskih Goricah Municipality",
      "183": "Šempeter–Vrtojba Municipality",
      "184": "Tabor Municipality",
      "185": "Trnovska Vas Municipality",
      "186": "Trzin Municipality",
      "187": "Velika Polana Municipality",
      "188": "Veržej Municipality",
      "189": "Vransko Municipality",
      "190": "Žalec Municipality",
      "191": "Žetale Municipality",
      "192": "Žirovnica Municipality",
      "193": "Žužemberk Municipality",
      "194": "Šmartno pri Litiji Municipality",
      "195": "Municipality of Apače",
      "196": "Municipality of Cirkulane",
      "197": "Kostanjevica na Krki Municipality",
      "198": "Makole Municipality",
      "199": "Mokronog–Trebelno Municipality",
      "200": "Poljčane Municipality",
      "201": "Renče–Vogrsko Municipality",
      "202": "Središče ob Dravi",
      "203": "Straža Municipality",
      "204": "Sveta Trojica v Slovenskih Goricah Municipality",
      "205": "Sveti Tomaž Municipality",
      "206": "Šmarješke Toplice Municipality",
      "207": "Gorje Municipality",
      "208": "Log–Dragomer Municipality",
      "209": "Rečica ob Savinji Municipality",
      "210": "Sveti Jurij v Slovenskih Goricah Municipality",
      "211": "Šentrupert Municipality",
      "212": "Mirna Municipality",
      "213": "Ankaran Municipality",
      "001": "Ajdovščina Municipality",
      "002": "Beltinci Municipality",
      "003": "Bled Municipality",
      "004": "Bohinj Municipality",
      "005": "Borovnica Municipality",
      "006": "Bovec Municipality",
      "007": "Brda Municipality",
      "008": "Brezovica Municipality",
      "009": "Brežice Municipality",
      "010": "Tišina Municipality",
      "011": "City Municipality of Celje",
      "012": "Cerklje na Gorenjskem Municipality",
      "013": "Cerknica Municipality",
      "014": "Cerkno Municipality",
      "015": "Črenšovci Municipality",
      "016": "Črna na Koroškem Municipality",
      "017": "Črnomelj Municipality",
      "018": "Destrnik Municipality",
      "019": "Divača Municipality",
      "020": "Dobrepolje Municipality",
      "021": "Dobrova–Polhov Gradec Municipality",
      "022": "Dol pri Ljubljani Municipality",
      "023": "Domžale Municipality",
      "024": "Dornava Municipality",
      "025": "Dravograd Municipality",
      "026": "Duplek Municipality",
      "027": "Gorenja Vas–Poljane Municipality",
      "028": "Gorišnica Municipality",
      "029": "Gornja Radgona Municipality",
      "030": "Gornji Grad Municipality",
      "031": "Gornji Petrovci Municipality",
      "032": "Grosuplje Municipality",
      "033": "Šalovci Municipality",
      "034": "Hrastnik Municipality",
      "035": "Hrpelje–Kozina Municipality",
      "036": "Idrija Municipality",
      "037": "Ig Municipality",
      "038": "Municipality of Ilirska Bistrica",
      "039": "Ivančna Gorica Municipality",
      "040": "Izola Municipality",
      "041": "Jesenice Municipality",
      "042": "Juršinci Municipality",
      "043": "Kamnik Municipality",
      "044": "Kanal ob Soči Municipality",
      "045": "Kidričevo Municipality",
      "046": "Kobarid Municipality",
      "047": "Kobilje Municipality",
      "048": "Kočevje Municipality",
      "049": "Komen Municipality",
      "050": "Koper City Municipality",
      "051": "Kozje Municipality",
      "052": "Kranj City Municipality",
      "053": "Kranjska Gora Municipality",
      "054": "Municipality of Krško",
      "055": "Kungota",
      "056": "Kuzma Municipality",
      "057": "Laško Municipality",
      "058": "Lenart Municipality",
      "059": "Lendava Municipality",
      "060": "Litija Municipality",
      "061": "Ljubljana City Municipality",
      "062": "Ljubno Municipality",
      "063": "Ljutomer Municipality",
      "064": "Logatec Municipality",
      "065": "Loška Dolina Municipality",
      "066": "Loški Potok Municipality",
      "067": "Luče Municipality",
      "068": "Lukovica Municipality",
      "069": "Majšperk Municipality",
      "070": "Maribor City Municipality",
      "071": "Medvode Municipality",
      "072": "Mengeš Municipality",
      "073": "Metlika Municipality",
      "074": "Mežica Municipality",
      "075": "Miren–Kostanjevica Municipality",
      "076": "Mislinja Municipality",
      "077": "Moravče Municipality",
      "078": "Moravske Toplice Municipality",
      "079": "Mozirje Municipality",
      "080": "Murska Sobota City Municipality",
      "081": "Muta Municipality",
      "082": "Naklo Municipality",
      "083": "Nazarje Municipality",
      "084": "Nova Gorica City Municipality",
      "085": "City Municipality of Novo Mesto",
      "086": "Odranci Municipality",
      "087": "Ormož Municipality",
      "088": "Osilnica Municipality",
      "089": "Pesnica Municipality",
      "090": "Piran Municipality",
      "091": "Pivka Municipality",
      "092": "Podčetrtek Municipality",
      "093": "Podvelka Municipality",
      "094": "Postojna Municipality",
      "095": "Preddvor Municipality",
      "096": "Ptuj City Municipality",
      "097": "Puconci Municipality",
      "098": "Rače–Fram Municipality",
      "099": "Radeče Municipality",
    },
    SK: {
      BC: "Banská Bystrica Region",
      BL: "Bratislava Region",
      KI: "Košice Region",
      NI: "Nitra Region",
      PV: "Prešov Region",
      TA: "Trnava Region",
      TC: "Trenčín Region",
      ZI: "Žilina Region",
    },
    SL: {
      E: "Eastern Province",
      N: "Northern Province",
      S: "Southern Province",
      W: "Western Area",
    },
    SM: {
      "01": "Acquaviva",
      "02": "Chiesanuova",
      "03": "Domagnano",
      "04": "Faetano",
      "05": "Fiorentino",
      "06": "Borgo Maggiore",
      "07": "San Marino",
      "08": "Montegiardino",
      "09": "Serravalle",
    },
    SN: {
      DB: "Diourbel Region",
      DK: "Dakar",
      FK: "Fatick",
      KA: "Kaffrine",
      KD: "Kolda",
      KE: "Kédougou",
      KL: "Kaolack",
      LG: "Louga",
      MT: "Matam",
      SE: "Sédhiou",
      SL: "Saint-Louis",
      TC: "Tambacounda Region",
      TH: "Thiès Region",
      ZG: "Ziguinchor",
    },
    SO: {
      AW: "Awdal Region",
      BK: "Bakool",
      BN: "Banaadir",
      BR: "Bari",
      BY: "Bay",
      GA: "Galguduud",
      GE: "Gedo",
      HI: "Hiran",
      JD: "Middle Juba",
      JH: "Lower Juba",
      MU: "Mudug",
      NU: "Nugal",
      SA: "Sanaag Region",
      SD: "Middle Shebelle",
      SH: "Lower Shebelle",
      TO: "Togdheer Region",
    },
    SR: {
      BR: "Brokopondo District",
      CM: "Commewijne District",
      CR: "Coronie District",
      MA: "Marowijne District",
      NI: "Nickerie District",
      PM: "Paramaribo District",
      PR: "Para District",
      SA: "Saramacca District",
      SI: "Sipaliwini District",
      WA: "Wanica District",
    },
    SS: {
      BN: "Northern Bahr el Ghazal",
      BW: "Western Bahr el Ghazal",
      EC: "Central Equatoria",
      EE: "Eastern Equatoria",
      EW: "Western Equatoria",
      JG: "Jonglei State",
      LK: "Lakes",
      NU: "Upper Nile",
      UY: "Unity",
      WR: "Warrap",
    },
    ST: {
      P: "Príncipe Province",
      S: "São Tomé Province",
    },
    SV: {
      AH: "Ahuachapán Department",
      CA: "Cabañas Department",
      CH: "Chalatenango Department",
      CU: "Cuscatlán Department",
      LI: "La Libertad Department",
      MO: "Morazán Department",
      PA: "La Paz Department",
      SA: "Santa Ana Department",
      SM: "San Miguel Department",
      SO: "Sonsonate Department",
      SS: "San Salvador Department",
      SV: "San Vicente Department",
      UN: "La Unión Department",
      US: "Usulután Department",
    },
    SY: {
      DI: "Damascus Governorate",
      DR: "Daraa Governorate",
      DY: "Deir ez-Zor Governorate",
      HA: "Al-Hasakah Governorate",
      HI: "Homs Governorate",
      HL: "Aleppo Governorate",
      HM: "Hama Governorate",
      ID: "Idlib Governorate",
      LA: "Latakia Governorate",
      QU: "Quneitra Governorate",
      RA: "Al-Raqqah Governorate",
      RD: "Rif Dimashq Governorate",
      SU: "As-Suwayda Governorate",
      TA: "Tartus Governorate",
    },
    SZ: {
      HH: "Hhohho District",
      LU: "Lubombo District",
      MA: "Manzini District",
      SH: "Shiselweni District",
    },
    TD: {
      BA: "Batha Region",
      BG: "Bahr el Gazel",
      BO: "Borkou",
      EE: "Ennedi-Est",
      EN: "Ennedi Region",
      EO: "Ennedi-Ouest",
      GR: "Guéra Region",
      HL: "Hadjer-Lamis",
      KA: "Kanem Region",
      LC: "Lac Region",
      LO: "Logone Occidental Region",
      LR: "Logone Oriental Region",
      MA: "Mandoul Region",
      MC: "Moyen-Chari Region",
      ME: "Mayo-Kebbi Est Region",
      MO: "Mayo-Kebbi Ouest Region",
      ND: "N'Djamena",
      OD: "Ouaddaï Region",
      SA: "Salamat Region",
      SI: "Sila Region",
      TA: "Tandjilé Region",
      TI: "Tibesti Region",
      WF: "Wadi Fira Region",
    },
    TG: {
      C: "Centrale Region",
      K: "Kara Region",
      M: "Maritime",
      P: "Plateaux Region",
      S: "Savanes Region",
    },
    TH: {
      "10": "Bangkok",
      "11": "Samut Prakan",
      "12": "Nonthaburi",
      "13": "Pathum Thani",
      "14": "Phra Nakhon Si Ayutthaya",
      "15": "Ang Thong",
      "16": "Lop Buri",
      "17": "Sing Buri",
      "18": "Chai Nat",
      "19": "Saraburi",
      "20": "Chon Buri",
      "21": "Rayong",
      "22": "Chanthaburi",
      "23": "Trat",
      "24": "Chachoengsao",
      "25": "Prachin Buri",
      "26": "Nakhon Nayok",
      "27": "Sa Kaeo",
      "30": "Nakhon Ratchasima",
      "31": "Buri Ram",
      "32": "Surin",
      "33": "Si Sa Ket",
      "34": "Ubon Ratchathani",
      "35": "Yasothon",
      "36": "Chaiyaphum",
      "37": "Amnat Charoen",
      "38": "Bueng Kan",
      "39": "Nong Bua Lam Phu",
      "40": "Khon Kaen",
      "41": "Udon Thani",
      "42": "Loei",
      "43": "Nong Khai",
      "44": "Maha Sarakham",
      "45": "Roi Et",
      "46": "Kalasin",
      "47": "Sakon Nakhon",
      "48": "Nakhon Phanom",
      "49": "Mukdahan",
      "50": "Chiang Mai",
      "51": "Lamphun",
      "52": "Lampang",
      "53": "Uttaradit",
      "54": "Phrae",
      "55": "Nan",
      "56": "Phayao",
      "57": "Chiang Rai",
      "58": "Mae Hong Son",
      "60": "Nakhon Sawan",
      "61": "Uthai Thani",
      "62": "Kamphaeng Phet",
      "63": "Tak",
      "64": "Sukhothai",
      "65": "Phitsanulok",
      "66": "Phichit",
      "67": "Phetchabun",
      "70": "Ratchaburi",
      "71": "Kanchanaburi",
      "72": "Suphan Buri",
      "73": "Nakhon Pathom",
      "74": "Samut Sakhon",
      "75": "Samut Songkhram",
      "76": "Phetchaburi",
      "77": "Prachuap Khiri Khan",
      "80": "Nakhon Si Thammarat",
      "81": "Krabi",
      "82": "Phangnga",
      "83": "Phuket",
      "84": "Surat Thani",
      "85": "Ranong",
      "86": "Chumphon",
      "90": "Songkhla",
      "91": "Satun",
      "92": "Trang",
      "93": "Phatthalung",
      "94": "Pattani",
      "95": "Yala",
      "96": "Narathiwat",
      S: "Pattaya",
    },
    TJ: {
      GB: "Gorno-Badakhshan Autonomous Province",
      KT: "Khatlon Province",
      RA: "districts of Republican Subordination",
      SU: "Sughd Province",
    },
    TL: {
      AL: "Aileu municipality",
      AN: "Ainaro Municipality",
      BA: "Baucau Municipality",
      BO: "Bobonaro Municipality",
      CO: "Cova Lima Municipality",
      DI: "Dili municipality",
      ER: "Ermera District",
      LA: "Lautém Municipality",
      LI: "Liquiçá Municipality",
      MF: "Manufahi Municipality",
      MT: "Manatuto District",
      VI: "Viqueque Municipality",
    },
    TM: {
      A: "Ahal Region",
      B: "Balkan Region",
      D: "Daşoguz Region",
      L: "Lebap Region",
      M: "Mary Region",
      S: "Ashgabat",
    },
    TN: {
      "11": "Tunis Governorate",
      "12": "Ariana Governorate",
      "13": "Ben Arous Governorate",
      "14": "Manouba Governorate",
      "22": "Zaghouan Governorate",
      "23": "Bizerte Governorate",
      "31": "Kassrine",
      "32": "Jendouba Governorate",
      "33": "Kef Governorate",
      "34": "Siliana Governorate",
      "41": "Kairouan Governorate",
      "42": "Kasserine Governorate",
      "43": "Sidi Bouzid Governorate",
      "51": "Sousse Governorate",
      "52": "Monastir Governorate",
      "53": "Mahdia Governorate",
      "61": "Sfax Governorate",
      "71": "Gafsa Governorate",
      "72": "Tozeur Governorate",
      "73": "Kebili Governorate",
      "81": "Gabès Governorate",
      "82": "Medenine Governorate",
      "83": "Tataouine Governorate",
    },
    TO: {
      "01": "ʻEua",
      "02": "Haʻapai",
      "03": "Niuas",
      "04": "Tongatapu",
      "05": "Vavaʻu",
    },
    TR: {
      "10": "Balıkesir",
      "11": "Bilecik",
      "12": "Bingöl",
      "13": "Bitlis",
      "14": "Bolu",
      "15": "Burdur",
      "16": "Bursa",
      "17": "Çanakkale",
      "18": "Çankırı",
      "19": "Çorum",
      "20": "Denizli",
      "21": "Diyarbakır",
      "22": "Edirne",
      "23": "Elazığ",
      "24": "Erzincan",
      "25": "Erzurum",
      "26": "Eskişehir",
      "27": "Gaziantep",
      "28": "Giresun",
      "29": "Gümüşhane",
      "30": "Hakkâri",
      "31": "Hatay",
      "32": "Isparta",
      "33": "Mersin",
      "34": "Istanbul",
      "35": "İzmir",
      "36": "Kars",
      "37": "Kastamonu",
      "38": "Kayseri",
      "39": "Kırklareli",
      "40": "Kırşehir",
      "41": "Kocaeli",
      "42": "Konya",
      "43": "Kütahya",
      "44": "Malatya",
      "45": "Manisa",
      "46": "Kahramanmaraş",
      "47": "Mardin",
      "48": "Muğla",
      "49": "Muş",
      "50": "Nevşehir",
      "51": "Niğde",
      "52": "Ordu",
      "53": "Rize",
      "54": "Sakarya",
      "55": "Samsun",
      "56": "Siirt",
      "57": "Sinop",
      "58": "Sivas",
      "59": "Tekirdağ",
      "60": "Tokat",
      "61": "Trabzon",
      "62": "Tunceli",
      "63": "Şanlıurfa",
      "64": "Uşak",
      "65": "Van",
      "66": "Yozgat",
      "67": "Zonguldak",
      "68": "Aksaray",
      "69": "Bayburt",
      "70": "Karaman",
      "71": "Kırıkkale",
      "72": "Batman",
      "73": "Şırnak",
      "74": "Bartın",
      "75": "Ardahan",
      "76": "Iğdır",
      "77": "Yalova",
      "78": "Karabük",
      "79": "Kilis",
      "80": "Osmaniye",
      "81": "Düzce",
      "01": "Adana",
      "02": "Adıyaman",
      "03": "Afyonkarahisar",
      "04": "Ağrı",
      "05": "Amasya",
      "06": "Ankara",
      "07": "Antalya",
      "08": "Artvin",
      "09": "Aydın",
    },
    TT: {
      ARI: "Arima",
      CHA: "Chaguanas",
      CTT: "Couva-Tabaquite-Talparo Regional Corporation",
      DMN: "Diego Martin Regional Corporation",
      ETO: "Eastern Tobago",
      MRC: "Rio Claro-Mayaro Regional Corporation",
      PED: "Penal-Debe Regional Corporation",
      POS: "Port of Spain",
      PRT: "Princes Town Regional Corporation",
      PTF: "Point Fortin",
      SFO: "San Fernando",
      SGE: "Sangre Grande Regional Corporation",
      SIP: "Siparia Regional Corporation",
      SJL: "San Juan-Laventille Regional Corporation",
      TUP: "Tunapuna-Piarco Regional Corporation",
      WTO: "Western Tobago",
    },
    TV: {
      FUN: "Funafuti",
      NIT: "Niutao Island Council",
      NKF: "Nukufetau",
      NKL: "Nukulaelae",
      NMA: "Nanumea",
      NMG: "Nanumanga",
      NUI: "Nui",
      VAI: "Vaitupu",
    },
    TW: {
      CHA: "Changhua",
      CYI: "Chiayi",
      CYQ: "Chiayi",
      HSQ: "Hsinchu",
      HSZ: "Hsinchu",
      HUA: "Hualien",
      ILA: "Yilan",
      KEE: "Keelung",
      KHH: "Kaohsiung",
      KIN: "Kinmen",
      LIE: "Lienchiang",
      MIA: "Miaoli",
      NAN: "Nantou",
      NWT: "New Taipei",
      PEN: "Penghu",
      PIF: "Pingtung",
      TAO: "Taoyuan",
      TNN: "Tainan",
      TPE: "Taipei",
      TTT: "Taitung",
      TXG: "Taichung",
      YUN: "Yunlin",
    },
    TZ: {
      "10": "Pemba South",
      "11": "Zanzibar South",
      "12": "Lindi",
      "13": "Mara",
      "14": "Mbeya",
      "15": "Zanzibar West",
      "16": "Morogoro",
      "17": "Mtwara",
      "18": "Mwanza",
      "19": "Pwani",
      "20": "Rukwa",
      "21": "Ruvuma",
      "22": "Shinyanga",
      "23": "Singida",
      "24": "Tabora",
      "25": "Tanga",
      "26": "Manyara",
      "27": "Geita",
      "28": "Katavi",
      "29": "Njombe",
      "30": "Simiyu",
      "31": "Songwe",
      "01": "Arusha",
      "02": "Dar es Salaam",
      "03": "Dodoma",
      "04": "Iringa",
      "05": "Kagera",
      "06": "Pemba North",
      "07": "Zanzibar North",
      "08": "Kigoma",
      "09": "Kilimanjaro",
    },
    UA: {
      "12": "Dnipropetrovska oblast",
      "14": "Donetska oblast",
      "18": "Zhytomyrska oblast",
      "21": "Zakarpatska Oblast",
      "23": "Zaporizka oblast",
      "26": "Ivano-Frankivska oblast",
      "30": "Kyiv",
      "32": "Kyivska oblast",
      "35": "Kirovohradska oblast",
      "43": "Autonomous Republic of Crimea",
      "46": "Lvivska oblast",
      "48": "Mykolaivska oblast",
      "51": "Odeska oblast",
      "53": "Poltavska oblast",
      "56": "Rivnenska oblast",
      "59": "Sumska oblast",
      "61": "Ternopilska oblast",
      "63": "Kharkivska oblast",
      "65": "Khersonska oblast",
      "68": "Khmelnytska oblast",
      "71": "Cherkaska oblast",
      "74": "Chernihivska oblast",
      "77": "Chernivetska oblast",
      "05": "Vinnytska oblast",
      "07": "Volynska oblast",
      "09": "Luhanska oblast",
    },
    UG: {
      "101": "Kalangala District",
      "102": "Kampala District",
      "103": "Kiboga District",
      "104": "Luwero District",
      "105": "Masaka District",
      "106": "Mpigi District",
      "107": "Mubende District",
      "108": "Mukono District",
      "109": "Nakasongola District",
      "110": "Rakai District",
      "111": "Sembabule District",
      "112": "Kayunga District",
      "113": "Wakiso District",
      "114": "Lyantonde District",
      "115": "Mityana District",
      "116": "Nakaseke District",
      "117": "Buikwe District",
      "118": "Bukomansimbi District",
      "119": "Butambala District",
      "120": "Buvuma District",
      "121": "Gomba District",
      "122": "Kalungu District",
      "123": "Kyankwanzi District",
      "124": "Lwengo District",
      "125": "Kyotera District",
      "201": "Bugiri District",
      "202": "Busia District",
      "203": "Iganga District",
      "204": "Jinja District",
      "205": "Kamuli District",
      "206": "Kapchorwa District",
      "207": "Katakwi District",
      "208": "Kumi District",
      "209": "Mbale District",
      "210": "Pallisa District",
      "211": "Soroti District",
      "212": "Tororo District",
      "213": "Kaberamaido District",
      "214": "Mayuge District",
      "215": "Sironko District",
      "216": "Amuria District",
      "217": "Budaka District",
      "218": "Bududa District",
      "219": "Bukedea District",
      "220": "Bukwo District",
      "221": "Butaleja District",
      "222": "Kaliro District",
      "223": "Manafwa District",
      "224": "Namutumba District",
      "225": "Bulambuli District",
      "226": "Buyende District",
      "227": "Kibuku District",
      "228": "Kween District",
      "229": "Luuka District",
      "230": "Namayingo District",
      "231": "Ngora District",
      "232": "Serere District",
      "233": "Butebo District",
      "234": "Namisindwa District",
      "301": "Adjumani District",
      "302": "Apac District",
      "303": "Arua District",
      "304": "Gulu District",
      "305": "Kitgum District",
      "306": "Kotido District",
      "307": "Lira District",
      "308": "Moroto District",
      "309": "Moyo District",
      "310": "Nebbi District",
      "311": "Nakapiripirit District",
      "312": "Pader District",
      "313": "Yumbe District",
      "314": "Abim District",
      "315": "Amolatar District",
      "316": "Amuru District",
      "317": "Dokolo District",
      "318": "Kaabong District",
      "319": "Koboko District",
      "320": "Maracha District",
      "321": "Oyam District",
      "322": "Agago District",
      "323": "Alebtong District",
      "324": "Amudat District",
      "325": "Kole District",
      "326": "Lamwo District",
      "327": "Napak District",
      "328": "Nwoya District",
      "329": "Otuke District",
      "330": "Zombo District",
      "331": "Omoro District",
      "332": "Pakwach District",
      "401": "Bundibugyo District",
      "402": "Bushenyi District",
      "404": "Kabale District",
      "405": "Kabarole District",
      "406": "Kasese District",
      "407": "Kibaale District",
      "408": "Kisoro District",
      "409": "Masindi District",
      "410": "Mbarara District",
      "411": "Ntungamo District",
      "412": "Rukungiri District",
      "413": "Kamwenge District",
      "414": "Kanungu District",
      "415": "Kyenjojo District",
      "416": "Buliisa District",
      "417": "Ibanda District",
      "418": "Isingiro District",
      "419": "Kiruhura District",
      "420": "Buhweju District",
      "421": "Kiryandongo District",
      "422": "Kyegegwa District",
      "423": "Mitooma District",
      "424": "Ntoroko District",
      "425": "Rubirizi District",
      "426": "Sheema District",
      "427": "Kagadi District",
      "428": "Kakumiro District",
      "429": "Rubanda District",
      "430": "Bunyangabu District",
      "431": "Rukiga District",
      C: "Central Region",
      E: "Eastern Region",
      N: "Northern Region",
      W: "Western Region",
    },
    US: {
      AK: "Alaska",
      AL: "Alabama",
      AR: "Arkansas",
      AS: "American Samoa",
      AZ: "Arizona",
      CA: "California",
      CO: "Colorado",
      CT: "Connecticut",
      DC: "District of Columbia",
      DE: "Delaware",
      FL: "Florida",
      GA: "Georgia",
      GU: "Guam",
      HI: "Hawaii",
      IA: "Iowa",
      ID: "Idaho",
      IL: "Illinois",
      IN: "Indiana",
      KS: "Kansas",
      KY: "Kentucky",
      LA: "Louisiana",
      MA: "Massachusetts",
      MD: "Maryland",
      ME: "Maine",
      MI: "Michigan",
      MN: "Minnesota",
      MO: "Missouri",
      MP: "Northern Mariana Islands",
      MS: "Mississippi",
      MT: "Montana",
      NC: "North Carolina",
      ND: "North Dakota",
      NE: "Nebraska",
      NH: "New Hampshire",
      NJ: "New Jersey",
      NM: "New Mexico",
      NV: "Nevada",
      NY: "New York",
      OH: "Ohio",
      OK: "Oklahoma",
      OR: "Oregon",
      PA: "Pennsylvania",
      PR: "Puerto Rico",
      RI: "Rhode Island",
      SC: "South Carolina",
      SD: "South Dakota",
      TN: "Tennessee",
      TX: "Texas",
      UM: "United States Minor Outlying Islands",
      "UM-67": "Johnston Atoll",
      "UM-71": "Midway Atoll",
      "UM-76": "Navassa Island",
      "UM-79": "Wake Island",
      "UM-81": "Baker Island",
      "UM-84": "Howland Island",
      "UM-86": "Jarvis Island",
      "UM-89": "Kingman Reef",
      "UM-95": "Palmyra Atoll",
      UT: "Utah",
      VA: "Virginia",
      VI: "United States Virgin Islands",
      VT: "Vermont",
      WA: "Washington",
      WI: "Wisconsin",
      WV: "West Virginia",
      WY: "Wyoming",
    },
    UY: {
      AR: "Artigas Department",
      CA: "Canelones Department",
      CL: "Cerro Largo Department",
      CO: "Colonia Department",
      DU: "Durazno Department",
      FD: "Florida Department",
      FS: "Flores Department",
      LA: "Lavalleja Department",
      MA: "Maldonado Department",
      MO: "Montevideo Department",
      PA: "Paysandú Department",
      RN: "Río Negro Department",
      RO: "Rocha Department",
      RV: "Rivera Department",
      SA: "Salto Department",
      SJ: "San José Department",
      SO: "Soriano Department",
      TA: "Tacuarembó Department",
      TT: "Treinta y Tres Department",
    },
    UZ: {
      AN: "Andijan Region",
      BU: "Bukhara Region",
      FA: "Fergana Region",
      JI: "Jizzakh Region",
      NG: "Namangan Region",
      NW: "Navoiy Region",
      QA: "Qashqadaryo Region",
      QR: "Karakalpakstan",
      SA: "Samarqand Region",
      SI: "Sirdaryo Region",
      SU: "Surxondaryo Region",
      TK: "Tashkent",
      TO: "Tashkent Region",
      XO: "Xorazm Region",
    },
    VC: {
      "01": "Charlotte Parish",
      "02": "Saint Andrew Parish",
      "03": "Saint David Parish",
      "04": "Saint George Parish",
      "05": "Saint Patrick Parish",
      "06": "Grenadines Parish",
    },
    VE: {
      A: "Distrito Capital",
      B: "Anzoátegui",
      C: "Apure",
      D: "Aragua",
      E: "Barinas",
      F: "Bolívar",
      G: "Carabobo",
      H: "Cojedes",
      I: "Falcón",
      J: "Guárico",
      K: "Lara",
      L: "Mérida",
      M: "Miranda",
      N: "Monagas",
      O: "Nueva Esparta",
      P: "Portuguesa",
      R: "Sucre",
      S: "Táchira",
      T: "Trujillo",
      U: "Yaracuy",
      V: "Zulia",
      W: "Federal Dependencies of Venezuela",
      X: "La Guaira",
      Y: "Delta Amacuro",
      Z: "Amazonas",
    },
    VN: {
      "13": "Quảng Ninh",
      "14": "Hòa Bình",
      "18": "Ninh Bình",
      "20": "Thái Bình",
      "21": "Thanh Hóa",
      "22": "Nghệ An",
      "23": "Hà Tĩnh",
      "24": "Quảng Bình",
      "25": "Quảng Trị",
      "26": "Thừa Thiên-Huế",
      "27": "Quảng Nam",
      "28": "Kon Tum",
      "29": "Quảng Ngãi",
      "30": "Gia Lai",
      "31": "Bình Định",
      "32": "Phú Yên",
      "33": "Đắk Lắk",
      "34": "Khánh Hòa",
      "35": "Lâm Đồng",
      "36": "Ninh Thuận",
      "37": "Tây Ninh",
      "39": "Đồng Nai",
      "40": "Bình Thuận",
      "41": "Long An",
      "43": "Bà Rịa-Vũng Tàu",
      "44": "An Giang",
      "45": "Đồng Tháp",
      "46": "Tiền Giang",
      "47": "Kiên Giang",
      "49": "Vĩnh Long",
      "50": "Bến Tre",
      "51": "Trà Vinh",
      "52": "Sóc Trăng",
      "53": "Bắc Kạn",
      "54": "Bắc Giang",
      "55": "Bạc Liêu",
      "56": "Bắc Ninh",
      "57": "Bình Dương",
      "58": "Bình Phước",
      "59": "Cà Mau",
      "61": "Hải Dương",
      "63": "Hà Nam",
      "66": "Hưng Yên",
      "67": "Nam Định",
      "68": "Phú Thọ",
      "69": "Thái Nguyên",
      "70": "Vĩnh Phúc",
      "71": "Điện Biên",
      "72": "Đắk Nông",
      "73": "Hậu Giang",
      "01": "Lai Châu",
      "02": "Lào Cai",
      "03": "Hà Giang",
      "04": "Cao Bằng",
      "05": "Sơn La",
      "06": "Yên Bái",
      "07": "Tuyên Quang",
      "09": "Lạng Sơn",
      CT: "Cần Thơ",
      DN: "Đà Nẵng",
      HN: "Hà Nội",
      HP: "Hải Phòng",
      SG: "Hồ Chí Minh",
    },
    VU: {
      MAP: "Malampa",
      PAM: "Penama",
      SAM: "Sanma",
      SEE: "Shefa",
      TAE: "Tafea",
      TOB: "Torba",
    },
    WS: {
      AA: "A'ana",
      AL: "Aiga-i-le-Tai",
      AT: "Atua",
      FA: "Fa'asaleleaga",
      GE: "Gaga'emauga",
      GI: "Gaga'ifomauga",
      PA: "Palauli",
      SA: "Satupa'itea",
      TU: "Tuamasaga",
      VF: "Va'a-o-Fonoti",
      VS: "Vaisigano",
    },
    XK: {
      XDG: "Đakovica District (Gjakove)",
      XGJ: "Gjilan District",
      XKM: "Kosovska Mitrovica District",
      XPE: "Peć District",
      XPI: "Pristina (Priştine)",
      XPR: "Prizren District",
      XUF: "Uroševac District (Ferizaj)",
    },
    YE: {
      AB: "Abyan Governorate",
      AD: "'Adan Governorate",
      AM: "'Amran Governorate",
      BA: "Al Bayda' Governorate",
      DH: "Dhamar Governorate",
      HD: "Hadhramaut Governorate",
      HJ: "Hajjah Governorate",
      HU: "Al Hudaydah Governorate",
      IB: "Ibb Governorate",
      JA: "Al Jawf Governorate",
      LA: "Lahij Governorate",
      MA: "Ma'rib Governorate",
      MR: "Al Mahrah Governorate",
      MW: "Al Mahwit Governorate",
      RA: "Raymah Governorate",
      SA: "Sana'a",
      SD: "Saada Governorate",
      SH: "Shabwah Governorate",
      SN: "Sana'a Governorate",
      SU: "Socotra Governorate",
      TA: "Ta'izz Governorate",
    },
    ZA: {
      EC: "Eastern Cape",
      FS: "Free State",
      GP: "Gauteng",
      KZN: "KwaZulu-Natal",
      LP: "Limpopo",
      MP: "Mpumalanga",
      NC: "Northern Cape",
      NW: "North West",
      WC: "Western Cape",
    },
    ZM: {
      "10": "Muchinga Province",
      "01": "Western Province",
      "02": "Central Province",
      "03": "Eastern Province",
      "04": "Luapula Province",
      "05": "Northern Province",
      "06": "Northwestern Province",
      "07": "Southern Province",
      "08": "Copperbelt Province",
      "09": "Lusaka Province",
    },
    ZW: {
      BU: "Bulawayo Province",
      HA: "Harare Province",
      MA: "Manicaland",
      MC: "Mashonaland Central Province",
      ME: "Mashonaland East Province",
      MI: "Midlands Province",
      MN: "Matabeleland North Province",
      MS: "Matabeleland South Province",
      MV: "Masvingo Province",
      MW: "Mashonaland West Province",
    },
  },
};
